import merge from "lodash.merge";
import * as React from "react";
import React__default, { createContext, useContext, forwardRef, createElement, Fragment, useMemo, useState, useEffect } from "react";
import clone from "lodash.clonedeep";
import { withEmotionCache as withEmotionCache$1, ThemeContext as ThemeContext$2, css, Global } from "@emotion/react";
const defaultTheme = {
  colors: {
    primary: "black"
  },
  fonts: {
    primary: {
      fontFamily: "Raleway",
      fontWeight: 700,
      fontStyle: "normal"
    },
    secondary: {
      fontFamily: "Source Sans Pro",
      fontWeight: 400,
      fontStyle: "normal"
    }
  }
};
const getDefaultTheme = () => {
  return clone(defaultTheme);
};
const ThemeContext$1 = createContext(defaultTheme);
const ThemeProvider = ThemeContext$1.Provider;
const useTheme = () => {
  return useContext(ThemeContext$1);
};
const mq = {
  sm: "@media screen and (max-width: 480px)",
  md: "@media screen and (max-width: 768px)",
  lg: "@media screen and (max-width: 960px)",
  xl: "@media screen and (max-width: 1200px)"
};
var TemplateName = /* @__PURE__ */ ((TemplateName2) => {
  TemplateName2["BASIC"] = "BASIC";
  TemplateName2["MINIMAL_BOOKING_PAGE"] = "MINIMAL_BOOKING_PAGE";
  TemplateName2["BUSINESS_CARD_BASIC"] = "BUSINESS_CARD_BASIC";
  return TemplateName2;
})(TemplateName || {});
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["CONTAINED"] = "CONTAINED";
  ButtonVariant2["OUTLINED"] = "OUTLINED";
  return ButtonVariant2;
})(ButtonVariant || {});
var Social = /* @__PURE__ */ ((Social2) => {
  Social2["linkedIn"] = "linkedIn";
  Social2["youTube"] = "youTube";
  Social2["facebook"] = "facebook";
  Social2["twitter"] = "twitter";
  Social2["instagram"] = "instagram";
  Social2["tikTok"] = "tikTok";
  Social2["telegram"] = "telegram";
  return Social2;
})(Social || {});
var LogoDisplayVariant = /* @__PURE__ */ ((LogoDisplayVariant2) => {
  LogoDisplayVariant2["TEXT"] = "TEXT";
  LogoDisplayVariant2["IMAGE"] = "IMAGE";
  return LogoDisplayVariant2;
})(LogoDisplayVariant || {});
var SectionContainerId = /* @__PURE__ */ ((SectionContainerId2) => {
  SectionContainerId2["HEADER_WRAPPER"] = "HEADER_WRAPPER";
  SectionContainerId2["HERO_WRAPPER"] = "HERO_WRAPPER";
  SectionContainerId2["CONTACTS_WRAPPER"] = "CONTACTS_WRAPPER";
  SectionContainerId2["ABOUT_WRAPPER"] = "ABOUT_WRAPPER";
  SectionContainerId2["JOBS_WRAPPER"] = "JOBS_WRAPPER";
  SectionContainerId2["SKILLS_WRAPPER"] = "SKILLS_WRAPPER";
  SectionContainerId2["EXPERIENCE_WRAPPER"] = "EXPERIENCE_WRAPPER";
  return SectionContainerId2;
})(SectionContainerId || {});
const defaultContent = {
  header: {
    logoText: {
      value: "Kobzar Production"
    },
    logoImage: {
      value: "https://workee.net/pic/logos/workee-logo-black.svg"
    },
    logoDisplayVariant: LogoDisplayVariant.TEXT,
    primaryAction: {
      variant: ButtonVariant.CONTAINED,
      value: "Book me"
    }
  },
  hero: {
    name: {
      value: "Mr. Taras Shevchenko"
    },
    title: {
      value: "Founder Moore Sport"
    },
    description: {
      value: "The relationships between the employer and workers always affect the growth of the business. Internal conflicts always make the development of the company impossible. I am convinced that the labour relationships demand emphasis and specific legal regulation. I am basing consultations on legislation, judicial practice, explanations of public authorities."
    },
    image: {
      value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
    },
    primaryAction: {
      variant: ButtonVariant.CONTAINED,
      value: "Book me"
    },
    secondaryAction: {
      variant: ButtonVariant.OUTLINED,
      value: "Ask me question"
    }
  },
  contacts: {
    phone: {
      value: "+1 917-414-7949",
      isVisible: true
    },
    email: {
      value: "dr.hayden.aaron@gmail.com",
      isVisible: true
    },
    address: {
      value: "244 5th Ave #2, New York, NY 10001, USA",
      isVisible: true
    },
    socials: {
      linkedIn: {
        id: Social.linkedIn,
        value: "https://www.linkedin.com/in/ihor-bauman/",
        isVisible: true
      },
      youTube: {
        id: Social.youTube,
        value: "https://www.youtube.com/channel/UCZ8wMb2WEaO1KbUaOdpCzaQ",
        isVisible: true
      },
      facebook: {
        id: Social.facebook,
        value: "https://www.facebook.com/ihor.bauman/",
        isVisible: true
      },
      twitter: {
        id: Social.twitter,
        value: "https://twitter.com/bauman_igor",
        isVisible: true
      },
      instagram: {
        id: Social.instagram,
        value: "",
        isVisible: false
      },
      tikTok: {
        id: Social.tikTok,
        value: "",
        isVisible: false
      },
      telegram: {
        id: Social.telegram,
        value: "https://@T_be_D",
        isVisible: false
      }
    },
    availability: {
      isAvailable: true,
      periods: []
    }
  },
  about: {
    isVisible: true,
    caption: {
      value: "About me"
    },
    description: {
      value: "I swear by Apollo Physician, by Asclepius, by Hygieia, by Panacea, and by all the gods and goddesses, making them my witnesses, that I will carry out, according to my ability and judgment, this oath and this indenture. To hold my teacher in this art equal to my own parents; to make him partner in my livelihood; when he is in need of money to share mine with him; to consider his family as my own brothers, and to teach them this art, if they want to learn it, without fee or indenture; to impart precept, oral instruction, and all other instruction to my own sons, the sons of my teacher, and to indentured pupils who have taken the physician\u2019s oath, but to nobody else..."
    },
    image: {
      value: "https://images.unsplash.com/photo-1566475955255-404134a79aeb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80"
    }
  },
  jobs: {
    isVisible: true,
    caption: {
      value: "One-time services"
    },
    jobsList: [{
      id: "1",
      title: "Diet plan for fitness training 1 title",
      description: "Just in case you need to hear this, you don't have to lose weight to be happy or fall in love. Not to get the job of your dreams. If you want to lose weight to get healthier? Great. Just know that body size isn't the end-all, be-all of determining",
      image: {
        value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
      },
      price: "150.00"
    }, {
      id: "2",
      title: "Diet plan for fitness training 2 title",
      description: "Just in case you need to hear this, you don't have to lose weight to be happy or fall in love. Not to get the job of your dreams. If you want to lose weight to get healthier? Great. Just know that body size isn't the end-all, be-all of determining",
      image: {
        value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
      },
      price: "250.00"
    }, {
      id: "3",
      title: "Diet plan for fitness training 3 title",
      description: "Just in case you need to hear this, you don't have to lose weight to be happy or fall in love. Not to get the job of your dreams. If you want to lose weight to get healthier? Great. Just know that body size isn't the end-all, be-all of determining",
      image: {
        value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
      },
      price: "0.00"
    }, {
      id: "4",
      title: "Diet plan for fitness training 4 title",
      description: "Diet plan for fitness training 4 description",
      image: {
        value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
      },
      price: "500.00"
    }, {
      id: "5",
      title: "Diet plan for fitness training 5 title",
      description: "Diet plan for fitness training 5 description",
      image: {
        value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
      },
      price: "10.00"
    }, {
      id: "6",
      title: "Diet plan for fitness training 6 title",
      description: "Diet plan for fitness training 6 description",
      image: {
        value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
      },
      price: "1000.00"
    }, {
      id: "7",
      title: "Diet plan for fitness training 7 title",
      description: "Diet plan for fitness training 7 description",
      image: {
        value: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Taras_Shevchenko_selfportrait_oil_1840-2.jpg/220px-Taras_Shevchenko_selfportrait_oil_1840-2.jpg"
      },
      price: "0.00"
    }]
  },
  skills: {
    isVisible: true,
    caption: {
      value: "Skills"
    },
    skillsList: [{
      title: "Gestalt psychology",
      description: "To hold my teacher in this art equal to my own parents; to make him partner in my livelihood; when he is in need of money to share mine with him; to consider his family as my own brothers, and to teach them this art, if they want to learn it, without fee or indenture."
    }, {
      title: "Behaviorism",
      description: "Without fee or indenture; to impart precept, oral instruction and all other instruction to my own sons, the sons of my teacher, and to indentured pupils who have taken the physician\u2019s oath, but to nobody else."
    }, {
      title: "Cognitive psychology",
      description: "Cognitive psychology is defined as the study of individual-level mental processes such as information processing, attention, language use, memory, perception, problem solving, decision-making, and thinking (Gerrig and Zimbardo 2002). A core assumption of analyzing corrupt behavior through a cognitive psychology lens is that individuals make conscious decisions to engage in corrupt behavior."
    }, {
      title: "Freudianism",
      description: "The radically new model of the human mind proposed by Sigmund Freud (1856-1939), the inventor of modern psychology and psychoanalysis, changed the way we all think about ourselves, our language, and our culture. Drawing upon both nineteenth-century science and nineteenth-century Romanticism, Freud created a description of the mind that emphasizes the major role played by unconscious drives, particularly those of sexuality. His theories, which struck many contemporaries as sordid and threatening, represents the most recent democratization or leveling of the old hierarchical conception of mind."
    }]
  },
  experience: {
    isVisible: true,
    caption: {
      value: "Experience"
    },
    experienceList: [{
      position: "Adjunct Professor ",
      organization: "Webster University",
      description: "Psychologist, Business consultant/coach",
      startDate: "12 Mar 2018",
      endDate: "12 Mar 2018",
      isCurrent: true
    }, {
      position: "Psychologist",
      organization: "Carla Burke LLC",
      description: "Business owner and CEO, Program development and evaluation",
      startDate: "23 Jul 2015",
      endDate: "14 Dec 2017",
      isCurrent: false
    }, {
      position: "Professor of Behavior Sciences",
      organization: "Northwest Missouri State University",
      description: "Summer Adjunct for Education CEUs",
      startDate: "9 Jul 2012",
      endDate: "14 Oct 2015",
      isCurrent: false
    }, {
      position: "Contract Consultant",
      organization: "Conception Abbey",
      description: "Program Development and Implementation for Adolescent Residential Care Facility",
      startDate: "6 Jan 2010",
      endDate: "6 Jan 2010",
      isCurrent: true
    }, {
      position: "Adjunct Professor",
      organization: "Park University",
      description: "Adjunct Professor of Psychology",
      startDate: "30 Jun 2005",
      endDate: "1 Dec 2010",
      isCurrent: false
    }]
  }
};
const getDefaultContent = () => {
  return clone(defaultContent);
};
const ContentContext = createContext(defaultContent);
const ContentProvider = ContentContext.Provider;
const useContent = () => {
  return useContext(ContentContext);
};
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3);
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index) {
  return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type, props, children, length2) {
  return { value, root, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root, props) {
  return assign(node("", null, null, "", null, null, 0), root, { length: -root.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index) {
  while (!token(peek()))
    next();
  return slice(index, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index = 0;
  var offset = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && characters2.charCodeAt(length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset:
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length2) {
  var post = offset - 1;
  var rule = offset === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k2 = 0; i < index; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z2 = value; x2 < size; ++x2)
      if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root, parent) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i = 0; i < length2; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index, children, callback) {
    var output = "";
    for (var i = 0; i < length2; i++)
      output += collection[i](element, index, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function prefixer(element, index, children, callback) {
  if (element.length > -1) {
    if (!element.return)
      switch (element.type) {
        case DECLARATION:
          element.return = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, { value: replace(element.value, "@", "@" + WEBKIT) })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, { props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")] })], callback);
                case "::placeholder":
                  return serialize([
                    copy(element, { props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")] }),
                    copy(element, { props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")] }),
                    copy(element, { props: [replace(value, /:(plac\w+)/, MS + "input-$1")] })
                  ], callback);
              }
              return "";
            });
      }
  }
}
function memoize(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index] = 1;
        }
        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;
      case 2:
        parsed[index] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index] = peek() === 58 ? "&\f" : "";
          points[index] = parsed[index].length;
          break;
        }
      default:
        parsed[index] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i = 0, k2 = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles) {
      return serialize(compile(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f$1 = b ? Symbol.for("react.strict_mode") : 60108, g$1 = b ? Symbol.for("react.profiler") : 60114, h$1 = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m$1 = b ? Symbol.for("react.concurrent_mode") : 60111, n$1 = b ? Symbol.for("react.forward_ref") : 60112, p$1 = b ? Symbol.for("react.suspense") : 60113, q$1 = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m$1:
          case e:
          case g$1:
          case f$1:
          case p$1:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n$1:
              case t:
              case r:
              case h$1:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m$1;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m$1;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h$1;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n$1;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g$1;
reactIs_production_min.StrictMode = f$1;
reactIs_production_min.Suspense = p$1;
reactIs_production_min.isAsyncMode = function(a) {
  return A(a) || z(a) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function(a) {
  return z(a) === k;
};
reactIs_production_min.isContextProvider = function(a) {
  return z(a) === h$1;
};
reactIs_production_min.isElement = function(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function(a) {
  return z(a) === n$1;
};
reactIs_production_min.isFragment = function(a) {
  return z(a) === e;
};
reactIs_production_min.isLazy = function(a) {
  return z(a) === t;
};
reactIs_production_min.isMemo = function(a) {
  return z(a) === r;
};
reactIs_production_min.isPortal = function(a) {
  return z(a) === d;
};
reactIs_production_min.isProfiler = function(a) {
  return z(a) === g$1;
};
reactIs_production_min.isStrictMode = function(a) {
  return z(a) === f$1;
};
reactIs_production_min.isSuspense = function(a) {
  return z(a) === p$1;
};
reactIs_production_min.isValidElementType = function(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m$1 || a === g$1 || a === f$1 || a === p$1 || a === q$1 || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h$1 || a.$$typeof === k || a.$$typeof === n$1 || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles = interpolation.styles + ";";
        return styles;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);
    if (stringMode) {
      styles += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name,
    styles,
    next: cursor
  };
};
var hasOwnProperty$1 = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ createContext(
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ createContext({});
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty$1.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Noop$1 = function Noop() {
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, useContext(ThemeContext));
  insertStyles(cache, serialized, typeof type === "string");
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty$1.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  var ele = /* @__PURE__ */ createElement(type, newProps);
  var possiblyStyleElement = /* @__PURE__ */ createElement(Noop$1, null);
  return /* @__PURE__ */ createElement(Fragment, null, possiblyStyleElement, ele);
});
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from2;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from2 = Object(arguments[s]);
    for (var key in from2) {
      if (hasOwnProperty.call(from2, key)) {
        to[key] = from2[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from2);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from2, symbols[i])) {
          to[symbols[i]] = from2[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React__default, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c2, a, k2) {
  var b2, d2 = {}, e2 = null, l2 = null;
  void 0 !== k2 && (e2 = "" + k2);
  void 0 !== a.key && (e2 = "" + a.key);
  void 0 !== a.ref && (l2 = a.ref);
  for (b2 in a)
    n.call(a, b2) && !p.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      void 0 === d2[b2] && (d2[b2] = a[b2]);
  return { $$typeof: g, type: c2, key: e2, ref: l2, props: d2, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs$1 = jsxRuntime.exports.jsxs;
function jsx(type, props, key) {
  if (!hasOwnProperty$1.call(props, "css")) {
    return jsx$1(type, props, key);
  }
  return jsx$1(Emotion, createEmotionProps(type, props), key);
}
function jsxs(type, props, key) {
  if (!hasOwnProperty$1.call(props, "css")) {
    return jsxs$1(type, props, key);
  }
  return jsxs$1(Emotion, createEmotionProps(type, props), key);
}
const Wrapper = ({
  id,
  children
}) => {
  return /* @__PURE__ */ jsx("div", {
    id,
    children
  });
};
const defaultWrappers = {
  header: {
    wrapper: Wrapper,
    logoText: {
      wrapper: Wrapper
    },
    logoImage: {
      wrapper: Wrapper
    },
    primaryAction: {
      wrapper: Wrapper
    }
  },
  hero: {
    wrapper: Wrapper,
    name: {
      wrapper: Wrapper
    },
    title: {
      wrapper: Wrapper
    },
    description: {
      wrapper: Wrapper
    },
    image: {
      wrapper: Wrapper
    },
    primaryAction: {
      wrapper: Wrapper
    },
    secondaryAction: {
      wrapper: Wrapper
    }
  },
  contacts: {
    wrapper: Wrapper
  },
  about: {
    wrapper: Wrapper,
    caption: {
      wrapper: Wrapper
    },
    description: {
      wrapper: Wrapper
    },
    image: {
      wrapper: Wrapper
    }
  },
  jobs: {
    wrapper: Wrapper,
    caption: {
      wrapper: Wrapper
    }
  },
  skills: {
    wrapper: Wrapper,
    caption: {
      wrapper: Wrapper
    }
  },
  experience: {
    wrapper: Wrapper,
    caption: {
      wrapper: Wrapper
    }
  }
};
const WrappersContext = createContext(defaultWrappers);
const WrappersProvider = WrappersContext.Provider;
const useWrappers = () => {
  return useContext(WrappersContext);
};
const noop = () => {
};
const defaultHandlers = {
  header: {
    primaryAction: {
      onClick: noop
    }
  },
  hero: {
    primaryAction: {
      onClick: noop
    },
    secondaryAction: {
      onClick: noop
    }
  },
  jobs: {
    onClick: noop
  }
};
const HandlersContext = createContext(defaultHandlers);
const HandlersProvider = HandlersContext.Provider;
const useHandlers = () => {
  return useContext(HandlersContext);
};
const generateActionStyles$2 = (theme, variant) => {
  if (variant === ButtonVariant.CONTAINED) {
    return {
      fontFamily: theme.fonts.primary.fontFamily,
      fontWeight: theme.fonts.primary.fontWeight,
      fontStyle: theme.fonts.primary.fontStyle,
      color: "rgba(255, 255, 255, 1)",
      backgroundColor: theme.colors.primary,
      borderColor: theme.colors.primary,
      borderRadius: "8px",
      transition: "opacity 150ms ease-in",
      hover: {
        opacity: 0.7
      }
    };
  }
  if (variant === ButtonVariant.OUTLINED) {
    return {
      fontFamily: theme.fonts.primary.fontFamily,
      fontWeight: theme.fonts.primary.fontWeight,
      fontStyle: theme.fonts.primary.fontStyle,
      color: theme.colors.primary,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: theme.colors.primary,
      borderRadius: "8px",
      transition: "opacity 150ms ease-in",
      hover: {
        opacity: 0.7
      }
    };
  }
  return {
    fontFamily: theme.fonts.primary.fontFamily,
    fontWeight: theme.fonts.primary.fontWeight,
    fontStyle: theme.fonts.primary.fontStyle,
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: theme.colors.primary,
    borderColor: theme.colors.primary,
    borderRadius: "8px",
    transition: "opacity 150ms ease-in",
    hover: {
      opacity: 0.7
    }
  };
};
const generateTemplateStyles$2 = (theme, content) => {
  return {
    header: {
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      logoText: {
        color: theme.colors.primary,
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      primaryAction: generateActionStyles$2(theme, content.header.primaryAction.variant)
    },
    hero: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      name: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      title: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      image: {
        borderRadius: "64px"
      },
      primaryAction: generateActionStyles$2(theme, content.hero.primaryAction.variant),
      secondaryAction: generateActionStyles$2(theme, content.hero.secondaryAction.variant)
    },
    contacts: {
      color: "rgba(32, 32, 32, 1)",
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderRadius: "24px",
      boxShadow: "0px 8px 24px 0px rgba(32, 32, 32, 0.1), 0px 0px 2px 0px rgba(32, 32, 32, 0.5)",
      bg: {
        backgroundColor: "rgba(245, 245, 245, 1)"
      }
    },
    about: {
      backgroundColor: "rgba(245, 245, 245, 1)",
      caption: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      image: {
        borderRadius: "24px"
      }
    },
    jobs: {
      backgroundColor: "rgba(245, 245, 245, 1)",
      caption: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      list: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        listItem: {
          borderRadius: "24px",
          title: {
            fontFamily: theme.fonts.primary.fontFamily,
            fontWeight: theme.fonts.primary.fontWeight,
            fontStyle: theme.fonts.primary.fontStyle,
            color: "rgba(245, 245, 245, 1)"
          },
          price: {
            text: {
              fontFamily: theme.fonts.primary.fontFamily,
              fontWeight: theme.fonts.primary.fontWeight,
              fontStyle: theme.fonts.primary.fontStyle
            },
            backgroundColor: theme.colors.primary,
            buyAction: generateActionStyles$2(theme, ButtonVariant.CONTAINED)
          }
        }
      }
    },
    skills: {
      backgroundColor: "rgba(245, 245, 245, 1)",
      caption: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      list: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        boxShadow: "0px 0px 2px 0px rgba(32, 32, 32, 0.5)",
        borderRadius: "24px",
        listItem: {
          title: {
            fontFamily: theme.fonts.primary.fontFamily,
            fontWeight: theme.fonts.primary.fontWeight,
            fontStyle: theme.fonts.primary.fontStyle
          }
        }
      }
    },
    experience: {
      backgroundColor: "rgba(245, 245, 245, 1)",
      caption: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      list: {
        listItem: {
          position: {
            fontFamily: theme.fonts.primary.fontFamily,
            fontWeight: theme.fonts.primary.fontWeight,
            fontStyle: theme.fonts.primary.fontStyle
          },
          organization: {
            color: "rgba(32, 32, 32, 0.5)"
          }
        }
      }
    },
    availability: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      color: "rgba(32, 32, 32, 1)",
      caption: {
        name: {
          fontFamily: theme.fonts.primary.fontFamily,
          fontWeight: theme.fonts.primary.fontWeight,
          fontStyle: theme.fonts.primary.fontStyle
        },
        title: {
          color: "rgba(32, 32, 32, 0.4)"
        }
      },
      contacts: {
        borderRadius: "16px",
        boxShadow: "0px 0px 2px 0px rgba(32, 32, 32, 0.4)",
        label: {
          color: "rgba(32, 32, 32, 0.4)"
        }
      },
      booking: {
        boxShadow: "0px 0px 2px 0px rgba(32, 32, 32, 0.4)",
        borderRadius: "16px",
        bookMe: {
          fontFamily: theme.fonts.primary.fontFamily,
          fontWeight: theme.fonts.primary.fontWeight,
          fontStyle: theme.fonts.primary.fontStyle,
          color: theme.colors.primary
        }
      }
    },
    footer: {
      backgroundColor: "rgba(32, 32, 32, 1)",
      color: "rgba(255, 255, 255, 1)"
    }
  };
};
const TemplateStylesContext$2 = createContext(generateTemplateStyles$2(getDefaultTheme(), getDefaultContent()));
const TemplateStylesProvider$2 = ({
  theme,
  content,
  children
}) => {
  const value = useMemo(() => {
    return generateTemplateStyles$2(theme, content);
  }, [theme, content]);
  return /* @__PURE__ */ jsx(TemplateStylesContext$2.Provider, {
    value,
    children
  });
};
const useTemplateStyles$2 = () => {
  return useContext(TemplateStylesContext$2);
};
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
);
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
  return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
  return typeof tag === "string" && tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag, options, isReal) {
  var shouldForwardProp;
  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp !== "function" && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  return shouldForwardProp;
};
var Noop2 = function Noop3() {
  return null;
};
var createStyled = function createStyled2(tag, options) {
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
  }
  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles.push.apply(styles, args);
    } else {
      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles.push(args[i], args[0][i]);
      }
    }
    var Styled = withEmotionCache$1(function(props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props;
      if (props.theme == null) {
        mergedProps = {};
        for (var key in props) {
          mergedProps[key] = props[key];
        }
        mergedProps.theme = useContext(ThemeContext$2);
      }
      if (typeof props.className === "string") {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }
      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      insertStyles(cache, serialized, typeof finalTag === "string");
      className += cache.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === void 0 ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props) {
        if (shouldUseAs && _key === "as")
          continue;
        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }
      newProps.className = className;
      newProps.ref = ref;
      var ele = /* @__PURE__ */ createElement(finalTag, newProps);
      var possiblyStyleElement = /* @__PURE__ */ createElement(Noop2, null);
      return /* @__PURE__ */ createElement(Fragment, null, possiblyStyleElement, ele);
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, "toString", {
      value: function value() {
        if (targetClassName === void 0 && false) {
          return "NO_COMPONENT_SELECTOR";
        }
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      return createStyled2(nextTag, _extends({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };
    return Styled;
  };
};
const Header$2 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const HeaderWrapper = wrappers.header.wrapper;
  return /* @__PURE__ */ jsx(HeaderWrapper, {
    id: SectionContainerId.HEADER_WRAPPER,
    children: /* @__PURE__ */ jsx("header", {
      className,
      children
    })
  });
};
const StyledInput = /* @__PURE__ */ createStyled("span", {
  target: "e1sy680i0"
})(() => {
  return {
    margin: 0,
    padding: 0,
    fontFamily: "inherit",
    fontWeight: "inherit",
    fontStyle: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    textAlignLast: "inherit",
    textAlign: "inherit"
  };
}, "");
const Input = ({
  className,
  children,
  htmlTag = "span"
}) => {
  return /* @__PURE__ */ jsx(StyledInput, {
    className,
    as: htmlTag,
    children
  });
};
const LogoText$2 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const LogoTextWrapper = wrappers.header.logoText.wrapper;
  return /* @__PURE__ */ jsx(LogoTextWrapper, {
    id: "header-logoText-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "h1",
      children
    })
  });
};
var DefaultImagePlaceholder = "data:image/png;base64,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";
const StyledImage = /* @__PURE__ */ createStyled("img", {
  target: "ezundqt0"
})(() => {
  return {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover"
  };
}, "");
const Image$2 = ({
  className,
  src,
  placeholder = DefaultImagePlaceholder,
  ...htmlProps
}) => {
  return /* @__PURE__ */ jsx(StyledImage, {
    className,
    ...htmlProps,
    src: src || placeholder
  });
};
var LogoImagePlaceholder = "data:image/png;base64,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";
const LogoImage$2 = ({
  alt,
  className,
  src
}) => {
  const wrappers = useWrappers();
  const LogoImageWrapper = wrappers.header.logoImage.wrapper;
  return /* @__PURE__ */ jsx(LogoImageWrapper, {
    id: "header-logoImage-wrapper",
    children: /* @__PURE__ */ jsx(Image$2, {
      className,
      src,
      alt,
      placeholder: LogoImagePlaceholder
    })
  });
};
const StyledButton = /* @__PURE__ */ createStyled("button", {
  target: "e1ibjsvk0"
})(() => {
  return {
    padding: "8px 16px",
    cursor: "pointer",
    lineHeight: "22px",
    border: "1px solid transparent"
  };
}, "");
const Button = ({
  className,
  variant = ButtonVariant.CONTAINED,
  onClick = () => {
  },
  children,
  ...htmlProps
}) => {
  return /* @__PURE__ */ jsx(StyledButton, {
    className,
    variant,
    onClick,
    ...htmlProps,
    children
  });
};
const PrimaryAction$5 = ({
  variant,
  className,
  children
}) => {
  const wrappers = useWrappers();
  const handlers = useHandlers();
  const PrimaryActionWrapper = wrappers.header.primaryAction.wrapper;
  const handleClick = handlers.header.primaryAction.onClick;
  return /* @__PURE__ */ jsx(PrimaryActionWrapper, {
    id: "header-primaryAction-wrapper",
    children: /* @__PURE__ */ jsx(Button, {
      className,
      variant,
      onClick: handleClick,
      children
    })
  });
};
const HeaderContainer = /* @__PURE__ */ createStyled("div", {
  target: "e1gira7f5"
})(() => {
  return {
    position: "sticky",
    top: 0,
    zIndex: 12
  };
}, "");
const Section$8 = /* @__PURE__ */ createStyled(Header$2, {
  target: "e1gira7f4"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    logoText
  } = templateStyles.header;
  return {
    backgroundColor,
    display: "grid",
    gridTemplateColumns: "300px auto max-content",
    gap: "40px",
    alignItems: "center",
    width: "100%",
    padding: "16px 44px",
    minHeight: "88px",
    backdropFilter: "blur(64px)",
    [mq.sm]: {
      padding: "16px",
      minHeight: "64px"
    },
    "#header-logoText-wrapper": {
      fontFamily: logoText.fontFamily,
      fontWeight: logoText.fontWeight,
      fontStyle: logoText.fontStyle,
      color: logoText.color,
      fontSize: "24px",
      lineHeight: "150%"
    }
  };
}, "");
const LogoText$1 = /* @__PURE__ */ createStyled(LogoText$2, {
  target: "e1gira7f3"
})(() => {
  return {
    maxWidth: "300px"
  };
}, "");
const LogoImage$1 = /* @__PURE__ */ createStyled(LogoImage$2, {
  target: "e1gira7f2"
})(() => {
  return {
    height: "32px",
    objectFit: "cover",
    width: "auto",
    maxWidth: "300px"
  };
}, "");
const Menu = /* @__PURE__ */ createStyled("div", {
  target: "e1gira7f1"
})(() => {
  return {};
}, "");
const PrimaryAction$4 = /* @__PURE__ */ createStyled(PrimaryAction$5, {
  target: "e1gira7f0"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius
  } = templateStyles.header.primaryAction;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius,
    display: "inline-block",
    padding: "4px 16px",
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: "0.8"
    },
    [mq.md]: {
      display: "none"
    }
  };
}, "");
const Header$1 = () => {
  const content = useContent();
  const {
    logoText,
    logoImage,
    logoDisplayVariant,
    primaryAction
  } = content.header;
  return /* @__PURE__ */ jsx(HeaderContainer, {
    children: /* @__PURE__ */ jsxs(Section$8, {
      children: [logoDisplayVariant === LogoDisplayVariant.TEXT ? /* @__PURE__ */ jsx(LogoText$1, {
        children: logoText.value
      }) : null, logoDisplayVariant === LogoDisplayVariant.IMAGE ? /* @__PURE__ */ jsx(LogoImage$1, {
        src: logoImage.value,
        alt: "logo"
      }) : null, /* @__PURE__ */ jsx(Menu, {
        children: " "
      }), /* @__PURE__ */ jsx(PrimaryAction$4, {
        variant: primaryAction.variant,
        children: primaryAction.value
      })]
    })
  });
};
const Hero$3 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const HeroWrapper = wrappers.hero.wrapper;
  return /* @__PURE__ */ jsx(HeroWrapper, {
    id: SectionContainerId.HERO_WRAPPER,
    children: /* @__PURE__ */ jsx("article", {
      className,
      children
    })
  });
};
const Name$4 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const NameWrapper = wrappers.hero.name.wrapper;
  return /* @__PURE__ */ jsx(NameWrapper, {
    id: "hero-name-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "h1",
      children
    })
  });
};
const Title$5 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const TitleWrapper = wrappers.hero.title.wrapper;
  return /* @__PURE__ */ jsx(TitleWrapper, {
    id: "hero-title-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "h2",
      children
    })
  });
};
const Description$7 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const DescriptionWrapper = wrappers.hero.description.wrapper;
  return /* @__PURE__ */ jsx(DescriptionWrapper, {
    id: "hero-description-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "p",
      children
    })
  });
};
const Image$1 = ({
  alt,
  className,
  src
}) => {
  const wrappers = useWrappers();
  const ImageWrapper = wrappers.hero.image.wrapper;
  return /* @__PURE__ */ jsx(ImageWrapper, {
    id: "hero-image-wrapper",
    children: /* @__PURE__ */ jsx(Image$2, {
      className,
      src,
      alt
    })
  });
};
const PrimaryAction$3 = ({
  variant,
  className,
  children
}) => {
  const wrappers = useWrappers();
  const handlers = useHandlers();
  const PrimaryActionWrapper = wrappers.hero.primaryAction.wrapper;
  const handleClick = handlers.hero.primaryAction.onClick;
  return /* @__PURE__ */ jsx(PrimaryActionWrapper, {
    id: "hero-primaryAction-wrapper",
    children: /* @__PURE__ */ jsx(Button, {
      className,
      variant,
      onClick: handleClick,
      children
    })
  });
};
const SecondaryAction$3 = ({
  variant,
  className,
  children
}) => {
  const wrappers = useWrappers();
  const handlers = useHandlers();
  const SecondaryActionWrapper = wrappers.hero.secondaryAction.wrapper;
  const handleClick = handlers.hero.secondaryAction.onClick;
  return /* @__PURE__ */ jsx(SecondaryActionWrapper, {
    id: "hero-secondaryAction-wrapper",
    children: /* @__PURE__ */ jsx(Button, {
      className,
      variant,
      onClick: handleClick,
      children
    })
  });
};
const Section$7 = /* @__PURE__ */ createStyled(Hero$3, {
  target: "eh4l7zs11"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    name,
    title
  } = templateStyles.hero;
  return {
    backgroundColor,
    position: "relative",
    display: "flex",
    justifyContent: "center",
    padding: "120px 40px",
    paddingTop: "96px",
    [mq.lg]: {
      padding: "80px 40px",
      paddingTop: "48px"
    },
    [mq.sm]: {
      padding: "48px 24px"
    },
    "#hero-name-wrapper": {
      fontFamily: name.fontFamily,
      fontWeight: name.fontWeight,
      fontStyle: name.fontStyle,
      fontSize: "44px",
      lineHeight: "131%"
    },
    "#hero-title-wrapper": {
      fontFamily: title.fontFamily,
      fontWeight: title.fontWeight,
      fontStyle: title.fontStyle,
      fontSize: "24px",
      lineHeight: "130%"
    },
    "#hero-description-wrapper": {
      fontSize: "18px",
      lineHeight: "150%"
    }
  };
}, "");
const Body$6 = /* @__PURE__ */ createStyled("div", {
  target: "eh4l7zs10"
})(() => {
  return {
    width: "100%",
    maxWidth: "1110px",
    display: "grid",
    gridTemplateColumns: "auto 424px",
    gridTemplateAreas: `
      "content image"
      `,
    gap: "32px",
    alignItems: "center",
    [mq.lg]: {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto auto",
      gridTemplateAreas: `
        "image"
        "content"
        `,
      gap: "40px"
    }
  };
}, "");
const Content$6 = /* @__PURE__ */ createStyled("article", {
  target: "eh4l7zs9"
})(() => {
  return {
    gridArea: "content",
    display: "flex",
    flexDirection: "column",
    maxWidth: "540px",
    gap: "32px",
    [mq.lg]: {
      order: 2,
      alignItems: "stretch",
      textAlign: "center",
      maxWidth: "100%",
      textAlignLast: "center"
    }
  };
}, "");
const NameContainer = /* @__PURE__ */ createStyled("div", {
  target: "eh4l7zs8"
})(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  };
}, "");
const Name$3 = /* @__PURE__ */ createStyled(Name$4, {
  target: "eh4l7zs7"
})(() => {
  return {};
}, "");
const Title$4 = /* @__PURE__ */ createStyled(Title$5, {
  target: "eh4l7zs6"
})(() => {
  return {};
}, "");
const Description$6 = /* @__PURE__ */ createStyled(Description$7, {
  target: "eh4l7zs5"
})(() => {
  return {};
}, "");
const Actions$2 = /* @__PURE__ */ createStyled("div", {
  target: "eh4l7zs4"
})(() => {
  return {
    display: "flex",
    gap: "12px",
    [mq.lg]: {
      justifyContent: "center"
    }
  };
}, "");
const ImageContainer$1 = /* @__PURE__ */ createStyled("div", {
  target: "eh4l7zs3"
})(() => {
  return {
    [mq.lg]: {
      gridArea: "image",
      display: "flex",
      justifyContent: "center"
    }
  };
}, "");
const HeroImage$2 = /* @__PURE__ */ createStyled(Image$1, {
  target: "eh4l7zs2"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    borderRadius
  } = templateStyles.hero.image;
  return {
    borderRadius,
    aspectRatio: "1 / 1",
    width: "100%",
    [mq.lg]: {
      maxWidth: "250px"
    }
  };
}, "");
const PrimaryAction$2 = /* @__PURE__ */ createStyled(PrimaryAction$3, {
  target: "eh4l7zs1"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius
  } = templateStyles.hero.primaryAction;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius,
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: "0.8"
    }
  };
}, "");
const SecondaryAction$2 = /* @__PURE__ */ createStyled(SecondaryAction$3, {
  target: "eh4l7zs0"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius
  } = templateStyles.hero.secondaryAction;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius,
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: "0.8"
    }
  };
}, "");
const Hero$2 = () => {
  const content = useContent();
  const {
    name,
    title,
    description,
    image,
    primaryAction,
    secondaryAction
  } = content.hero;
  return /* @__PURE__ */ jsx(Section$7, {
    children: /* @__PURE__ */ jsxs(Body$6, {
      children: [/* @__PURE__ */ jsxs(Content$6, {
        children: [/* @__PURE__ */ jsxs(NameContainer, {
          children: [/* @__PURE__ */ jsx(Name$3, {
            children: name.value
          }), /* @__PURE__ */ jsx(Title$4, {
            children: title.value
          })]
        }), /* @__PURE__ */ jsx(Description$6, {
          children: description.value
        }), /* @__PURE__ */ jsxs(Actions$2, {
          children: [/* @__PURE__ */ jsx(PrimaryAction$2, {
            variant: primaryAction.variant,
            children: primaryAction.value
          }), /* @__PURE__ */ jsx(SecondaryAction$2, {
            variant: secondaryAction.variant,
            children: secondaryAction.value
          })]
        })]
      }), /* @__PURE__ */ jsx(ImageContainer$1, {
        children: /* @__PURE__ */ jsx(HeroImage$2, {
          src: image.value,
          alt: name.value
        })
      })]
    })
  });
};
const StyledLink = /* @__PURE__ */ createStyled("a", {
  target: "e1yk4d990"
})(() => {
  return {
    textDecoration: "none",
    color: "inherit"
  };
}, "");
const Link = ({
  children,
  ...htmlProps
}) => {
  return /* @__PURE__ */ jsx(StyledLink, {
    rel: "noreferrer noopener",
    target: "_blank",
    ...htmlProps,
    children
  });
};
const SvgLinkedIn = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5563 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2938 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516V20.4516Z",
  fill: "currentColor"
}));
const SvgYoutube = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M23.7609 7.20017C23.7609 7.20017 23.5266 5.54548 22.8047 4.81892C21.8906 3.86267 20.8688 3.85798 20.4 3.80173C17.0438 3.55798 12.0047 3.55798 12.0047 3.55798H11.9953C11.9953 3.55798 6.95625 3.55798 3.6 3.80173C3.13125 3.85798 2.10938 3.86267 1.19531 4.81892C0.473438 5.54548 0.24375 7.20017 0.24375 7.20017C0.24375 7.20017 0 9.14548 0 11.0861V12.9049C0 14.8455 0.239062 16.7908 0.239062 16.7908C0.239062 16.7908 0.473437 18.4455 1.19062 19.172C2.10469 20.1283 3.30469 20.0955 3.83906 20.1986C5.76094 20.3814 12 20.4377 12 20.4377C12 20.4377 17.0438 20.4283 20.4 20.1892C20.8688 20.133 21.8906 20.1283 22.8047 19.172C23.5266 18.4455 23.7609 16.7908 23.7609 16.7908C23.7609 16.7908 24 14.8502 24 12.9049V11.0861C24 9.14548 23.7609 7.20017 23.7609 7.20017ZM9.52031 15.1127V8.36736L16.0031 11.7517L9.52031 15.1127Z",
  fill: "currentColor"
}));
const SvgFacebook = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z",
  fill: "currentColor"
}));
const SvgTwitter = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M7.55016 21.7502C16.6045 21.7502 21.5583 14.2469 21.5583 7.74204C21.5583 7.53111 21.5536 7.31548 21.5442 7.10454C22.5079 6.40764 23.3395 5.54444 24 4.55548C23.1025 4.95478 22.1496 5.21556 21.1739 5.32892C22.2013 4.71309 22.9705 3.74565 23.3391 2.60595C22.3726 3.17874 21.3156 3.58279 20.2134 3.80079C19.4708 3.01174 18.489 2.4893 17.4197 2.31423C16.3504 2.13917 15.2532 2.32123 14.2977 2.83228C13.3423 3.34333 12.5818 4.15489 12.1338 5.14149C11.6859 6.1281 11.5754 7.2348 11.8195 8.29048C9.86249 8.19227 7.94794 7.68389 6.19998 6.79828C4.45203 5.91268 2.90969 4.66962 1.67297 3.1497C1.0444 4.23343 0.852057 5.51583 1.13503 6.73627C1.418 7.95672 2.15506 9.02363 3.19641 9.72017C2.41463 9.69535 1.64998 9.48486 0.965625 9.1061V9.16704C0.964925 10.3043 1.3581 11.4068 2.07831 12.287C2.79852 13.1671 3.80132 13.7707 4.91625 13.9952C4.19206 14.1933 3.43198 14.2222 2.69484 14.0795C3.00945 15.0576 3.62157 15.9131 4.44577 16.5265C5.26997 17.14 6.26512 17.4808 7.29234 17.5014C5.54842 18.8713 3.39417 19.6143 1.17656 19.6108C0.783287 19.6102 0.390399 19.5861 0 19.5386C2.25286 20.9839 4.87353 21.7516 7.55016 21.7502Z",
  fill: "currentColor"
}));
const SvgInstagram = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 5.83594C8.59688 5.83594 5.83594 8.59687 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59687 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z",
  fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M18.4078 7.03108C19.2 7.03108 19.8469 6.38889 19.8469 5.59202C19.8469 4.79983 19.2 4.15295 18.4078 4.15295C17.6156 4.15295 16.9688 4.79514 16.9688 5.59202C16.9688 6.38421 17.6109 7.03108 18.4078 7.03108Z",
  fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126562 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332813 4.90312 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332813 19.0969 0.628125 19.8562C0.9375 20.6484 1.34531 21.3187 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3187 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05937C23.8594 5.78437 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0ZM12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12187 20.4516 3.53906C20.8734 3.96094 21.1313 4.35937 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8688 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78437 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35937 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094Z",
  fill: "currentColor"
}));
const SvgTikTok = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M17.0725 0H13.0278V16.3478C13.0278 18.2957 11.4722 19.8957 9.53626 19.8957C7.60034 19.8957 6.04469 18.2957 6.04469 16.3478C6.04469 14.4348 7.56577 12.8695 9.43257 12.8V8.69567C5.31872 8.7652 2 12.1391 2 16.3478C2 20.5913 5.38786 24 9.57085 24C13.7538 24 17.1416 20.5565 17.1416 16.3478V7.9652C18.6627 9.07827 20.5295 9.73913 22.5 9.77393V5.66957C19.4579 5.56522 17.0725 3.06087 17.0725 0Z",
  fill: "currentColor"
}));
const SvgTelegram = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.43 8.85911C11.2628 9.34458 8.93008 10.3494 5.43183 11.8735C4.86377 12.0994 4.5662 12.3204 4.53911 12.5365C4.49333 12.9017 4.95065 13.0455 5.57341 13.2413C5.65812 13.2679 5.74589 13.2955 5.83588 13.3248C6.44858 13.524 7.27277 13.757 7.70123 13.7662C8.08988 13.7746 8.52367 13.6144 9.00258 13.2855C12.2711 11.0792 13.9583 9.96399 14.0642 9.93995C14.139 9.92299 14.2425 9.90166 14.3127 9.96403C14.3829 10.0264 14.376 10.1445 14.3685 10.1762C14.3232 10.3693 12.5281 12.0383 11.5991 12.902C11.3094 13.1712 11.104 13.3622 11.062 13.4058C10.9679 13.5035 10.8721 13.596 10.7799 13.6848C10.2107 14.2335 9.78385 14.645 10.8036 15.317C11.2936 15.6399 11.6857 15.9069 12.0769 16.1733C12.5041 16.4643 12.9302 16.7544 13.4816 17.1158C13.622 17.2079 13.7562 17.3036 13.8868 17.3967C14.384 17.7512 14.8307 18.0696 15.3825 18.0188C15.7032 17.9893 16.0344 17.6878 16.2026 16.7885C16.6002 14.6633 17.3816 10.0586 17.5622 8.16116C17.578 7.99491 17.5581 7.78215 17.5421 7.68876C17.5261 7.59536 17.4927 7.46229 17.3713 7.36378C17.2275 7.24712 17.0056 7.22252 16.9063 7.22427C16.455 7.23222 15.7625 7.473 12.43 8.85911Z",
  fill: "currentColor"
}));
const SvgEmail = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.37227 5.05143L10.1657 11.8463C11.2461 12.6812 12.7539 12.6812 13.8343 11.8463L22.6277 5.05143C22.865 5.48087 23 5.97467 23 6.5V16.5C23 18.1569 21.6569 19.5 20 19.5H4C2.34315 19.5 1 18.1569 1 16.5V6.5C1 5.97467 1.13503 5.48087 1.37227 5.05143ZM2.90314 3.70684C3.24288 3.57332 3.61288 3.5 4 3.5H20C20.3871 3.5 20.7571 3.57332 21.0969 3.70684L12.6114 10.2638C12.2513 10.542 11.7487 10.542 11.3886 10.2637L2.90314 3.70684Z",
  fill: "currentColor"
}));
const SvgPhone = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M9.64385 14.3557C11.1339 15.8457 12.6239 16.8246 14.3331 17.5115C14.8159 17.7055 15.3539 17.4531 15.5472 16.97L16.0401 15.7384C16.3447 14.9772 17.2118 14.6108 17.9699 14.923L21.0867 16.2064C21.8588 16.5243 22.2129 17.4194 21.8674 18.1795L20.7626 20.6102C20.0676 22 19.3724 21.9997 18.6778 22C14.5058 22.002 11.034 19.9153 7.55956 16.4408C4.08508 12.9663 2 9.49137 2 5.32194C2 4.62704 2 3.93213 3.38979 3.23723L5.82101 2.13248C6.58108 1.7871 7.47602 2.14128 7.79389 2.91327L9.07721 6.02994C9.38943 6.78821 9.02284 7.65552 8.26142 7.95997L7.02989 8.45239C6.5467 8.64559 6.2942 9.18374 6.48824 9.6666C7.1751 11.3758 8.1539 12.8657 9.64385 14.3557Z",
  fill: "currentColor"
}));
const Contacts$4 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const ContactsWrapper = wrappers.contacts.wrapper;
  return /* @__PURE__ */ jsx(ContactsWrapper, {
    id: SectionContainerId.CONTACTS_WRAPPER,
    children: /* @__PURE__ */ jsx("section", {
      className,
      children
    })
  });
};
const Section$6 = /* @__PURE__ */ createStyled(Contacts$4, {
  target: "e5dz9go6"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor: bgUpper
  } = templateStyles.contacts;
  const {
    backgroundColor: bgLower
  } = templateStyles.contacts.bg;
  return {
    backgroundColor: bgUpper,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    padding: "32px 0",
    "::after": {
      backgroundColor: bgLower,
      content: '""',
      width: "100%",
      height: "50%",
      position: "absolute",
      left: 0,
      bottom: 0,
      zIndex: 1
    }
  };
}, "");
const Container$h = /* @__PURE__ */ createStyled("div", {
  target: "e5dz9go5"
})(({
  isSocialsVisible,
  isMainContactsVisible
}) => {
  const templateStyles = useTemplateStyles$2();
  const {
    color,
    backgroundColor,
    borderRadius,
    boxShadow
  } = templateStyles.contacts;
  const styles = {
    color,
    backgroundColor,
    borderRadius,
    boxShadow,
    maxWidth: "1110px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "16px 32px",
    margin: "0 40px",
    zIndex: 2,
    [mq.md]: {
      flexDirection: "column",
      gap: "16px"
    },
    [mq.sm]: {
      padding: "16px",
      margin: "0 16px"
    }
  };
  if (!isSocialsVisible || !isMainContactsVisible) {
    styles.justifyContent = "center";
  }
  return styles;
}, "");
const SocialsList$2 = /* @__PURE__ */ createStyled("div", {
  target: "e5dz9go4"
})(() => {
  return {
    display: "flex",
    gap: "32px",
    alignItems: "center",
    justifyContent: "space-between",
    "> a": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "40px",
      height: "40px",
      transition: "transform 100ms ease-in",
      ":hover": {
        transform: "scale(1.2)"
      }
    },
    [mq.md]: {
      width: "100%",
      justifyContent: "space-around"
    }
  };
}, "");
const OthersList = /* @__PURE__ */ createStyled("div", {
  target: "e5dz9go3"
})(() => {
  return {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    alignItems: "center",
    "> a": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      lineHeight: "24px",
      padding: "8px 16px",
      borderRadius: "8px",
      transition: "background-color 100ms ease-in",
      ":hover": {
        backgroundColor: "rgba(32, 32, 32, 0.05)"
      }
    },
    [mq.sm]: {
      gap: "24px",
      "> a": {
        gap: "8px",
        padding: "4px 8px",
        svg: {
          display: "none"
        }
      }
    }
  };
}, "");
const Email$1 = /* @__PURE__ */ createStyled("a", {
  target: "e5dz9go2"
})(() => {
  return {
    textDecoration: "none",
    color: "inherit"
  };
}, "");
const Phone$1 = /* @__PURE__ */ createStyled("a", {
  target: "e5dz9go1"
})(() => {
  return {
    textDecoration: "none",
    color: "inherit"
  };
}, "");
const EmptyMessage$2 = /* @__PURE__ */ createStyled("p", {
  target: "e5dz9go0"
})(() => {
  return {
    fontSize: "16px",
    lineHeight: "150%",
    opacity: 0.5
  };
}, "");
const MAP_SOCIAL_TO_ICON$3 = {
  [Social.linkedIn]: SvgLinkedIn,
  [Social.youTube]: SvgYoutube,
  [Social.facebook]: SvgFacebook,
  [Social.twitter]: SvgTwitter,
  [Social.instagram]: SvgInstagram,
  [Social.tikTok]: SvgTikTok,
  [Social.telegram]: SvgTelegram
};
const Contacts$3 = () => {
  const content = useContent();
  const {
    email,
    phone,
    socials
  } = content.contacts;
  const isSocialsVisible = Object.values(socials).some((social) => {
    return social.isVisible;
  });
  const isMainContactsVisible = Boolean(email.isVisible || phone.isVisible);
  const renderSocialContacts = () => {
    return Object.values(socials).map((social) => {
      var _a;
      const SocialContactIcon = (_a = MAP_SOCIAL_TO_ICON$3[social.id]) != null ? _a : Fragment;
      if (social.isVisible) {
        return /* @__PURE__ */ jsx(Link, {
          href: social.value,
          children: /* @__PURE__ */ jsx(SocialContactIcon, {})
        }, social.id);
      }
      return null;
    });
  };
  return /* @__PURE__ */ jsx(Section$6, {
    children: /* @__PURE__ */ jsxs(Container$h, {
      isSocialsVisible,
      isMainContactsVisible,
      children: [isSocialsVisible ? /* @__PURE__ */ jsx(SocialsList$2, {
        children: renderSocialContacts()
      }) : null, isMainContactsVisible ? /* @__PURE__ */ jsxs(OthersList, {
        children: [email.isVisible ? /* @__PURE__ */ jsxs(Email$1, {
          href: `mailto:${email.value}`,
          children: [/* @__PURE__ */ jsx(SvgEmail, {}), /* @__PURE__ */ jsx(Input, {
            children: "Send email"
          })]
        }) : null, phone.isVisible ? /* @__PURE__ */ jsxs(Phone$1, {
          href: `tel:${phone.value}`,
          children: [/* @__PURE__ */ jsx(SvgPhone, {}), /* @__PURE__ */ jsx(Input, {
            children: "Call to phone"
          })]
        }) : null]
      }) : null, !isSocialsVisible && !isMainContactsVisible ? /* @__PURE__ */ jsx(EmptyMessage$2, {
        children: "Please add your contacts info"
      }) : null]
    })
  });
};
const About$2 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const AboutWrapper = wrappers.about.wrapper;
  return /* @__PURE__ */ jsx(AboutWrapper, {
    id: SectionContainerId.ABOUT_WRAPPER,
    children: /* @__PURE__ */ jsx("section", {
      className,
      children
    })
  });
};
const Caption$b = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const CaptionWrapper = wrappers.about.caption.wrapper;
  return /* @__PURE__ */ jsx(CaptionWrapper, {
    id: "about-caption-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "h2",
      children
    })
  });
};
const Description$5 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const DescriptionWrapper = wrappers.about.description.wrapper;
  return /* @__PURE__ */ jsx(DescriptionWrapper, {
    id: "about-description-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "p",
      children
    })
  });
};
const Image = ({
  alt,
  className,
  src
}) => {
  const wrappers = useWrappers();
  const ImageWrapper = wrappers.about.image.wrapper;
  return /* @__PURE__ */ jsx(ImageWrapper, {
    id: "about-image-wrapper",
    children: /* @__PURE__ */ jsx(Image$2, {
      className,
      src,
      alt
    })
  });
};
const Container$g = /* @__PURE__ */ createStyled(About$2, {
  target: "e15prd0r7"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    caption
  } = templateStyles.about;
  return {
    backgroundColor,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 40px",
    [mq.md]: {
      padding: "40px 40px"
    },
    [mq.sm]: {
      padding: "32px 24px"
    },
    "#about-caption-wrapper": {
      fontFamily: caption.fontFamily,
      fontWeight: caption.fontWeight,
      fontStyle: caption.fontStyle,
      fontSize: "40px",
      lineHeight: "131%"
    },
    "#about-description-wrapper": {
      fontSize: "18px",
      lineHeight: "150%"
    }
  };
}, "");
const Section$5 = /* @__PURE__ */ createStyled("div", {
  target: "e15prd0r6"
})(() => {
  return {
    width: "100%",
    maxWidth: "1110px",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    [mq.lg]: {
      gap: "32px"
    }
  };
}, "");
const Caption$a = /* @__PURE__ */ createStyled(Caption$b, {
  target: "e15prd0r5"
})(() => {
  return {
    width: "100%"
  };
}, "");
const Content$5 = /* @__PURE__ */ createStyled("div", {
  target: "e15prd0r4"
})(() => {
  return {
    display: "grid",
    gridTemplateColumns: "auto 424px",
    gridTemplateAreas: `
      "content image"
      `,
    gap: "32px",
    alignItems: "start",
    [mq.lg]: {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto auto",
      gridTemplateAreas: `
      "content"
      "image"
      `
    }
  };
}, "");
const Body$5 = /* @__PURE__ */ createStyled("article", {
  target: "e15prd0r3"
})(() => {
  return {
    gridArea: "content",
    maxWidth: "540px",
    [mq.lg]: {
      maxWidth: "100%"
    }
  };
}, "");
const Description$4 = /* @__PURE__ */ createStyled(Description$5, {
  target: "e15prd0r2"
})(() => {
  return {};
}, "");
const ImageContainer = /* @__PURE__ */ createStyled("div", {
  target: "e15prd0r1"
})(() => {
  return {
    gridArea: "image"
  };
}, "");
const UserImage$1 = /* @__PURE__ */ createStyled(Image, {
  target: "e15prd0r0"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    borderRadius
  } = templateStyles.about.image;
  return {
    borderRadius,
    width: "100%"
  };
}, "");
const About$1 = () => {
  const content = useContent();
  const {
    isVisible,
    caption,
    description,
    image
  } = content.about;
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsx(Container$g, {
    children: /* @__PURE__ */ jsxs(Section$5, {
      children: [/* @__PURE__ */ jsx(Caption$a, {
        children: caption.value
      }), /* @__PURE__ */ jsxs(Content$5, {
        children: [/* @__PURE__ */ jsx(Body$5, {
          children: /* @__PURE__ */ jsx(Description$4, {
            children: description.value
          })
        }), /* @__PURE__ */ jsx(ImageContainer, {
          children: /* @__PURE__ */ jsx(UserImage$1, {
            src: image.value,
            alt: "me"
          })
        })]
      })]
    })
  });
};
const initialValue = {
  slide: 0,
  length: 0,
  displayLength: 1,
  gap: 0,
  isPrevSlideAvailable: false,
  isNextSlideAvailable: false,
  onMoveToPrevSlide: () => {
  },
  onMoveToNextSlide: () => {
  }
};
const CarouselContext = createContext(initialValue);
const useCarouselContext = () => {
  return useContext(CarouselContext);
};
const CarouselContextProvider = ({
  slide,
  length: length2,
  displayLength,
  gap,
  isPrevSlideAvailable,
  isNextSlideAvailable,
  onMoveToPrevSlide,
  onMoveToNextSlide,
  children
}) => {
  const value = useMemo(() => {
    return {
      slide,
      gap,
      length: length2,
      displayLength,
      isPrevSlideAvailable,
      isNextSlideAvailable,
      onMoveToPrevSlide,
      onMoveToNextSlide
    };
  }, [slide, length2, displayLength, gap, isPrevSlideAvailable, isNextSlideAvailable]);
  return /* @__PURE__ */ jsx(CarouselContext.Provider, {
    value,
    children
  });
};
const StyledCarouselListItem = /* @__PURE__ */ createStyled("li", {
  target: "e15qjl270"
})(({
  length: length2,
  displayLength,
  gap
}) => {
  return {
    width: `calc(100% / ${length2} - ${gap * (displayLength - 1) / displayLength}px)`,
    flex: `0 0 calc(100% / ${length2} - ${gap * (displayLength - 1) / displayLength}px)`
  };
}, "");
const CarouselListItem = ({
  className,
  children
}) => {
  const {
    length: length2,
    displayLength,
    gap
  } = useCarouselContext();
  return /* @__PURE__ */ jsx(StyledCarouselListItem, {
    className,
    length: length2,
    displayLength,
    gap,
    children
  });
};
const StyledCarouselList = /* @__PURE__ */ createStyled("ul", {
  target: "e1cwlsu90"
})(({
  slide,
  length: length2,
  displayLength,
  gap
}) => {
  return {
    width: `calc(100% * ${length2 / displayLength})`,
    display: "flex",
    gap: `${gap}px`,
    height: "100%",
    listStyle: "none",
    margin: 0,
    padding: 0,
    transform: `translateX(calc((-100% / ${length2} + ${gap}px * ${displayLength - 1} / ${displayLength} - ${gap}px) * ${slide}))`,
    transition: "all 0.4s"
  };
}, "");
const CarouselList = ({
  className,
  children
}) => {
  const {
    slide,
    length: length2,
    displayLength,
    gap
  } = useCarouselContext();
  return /* @__PURE__ */ jsx(StyledCarouselList, {
    className,
    slide,
    length: length2,
    displayLength,
    gap,
    children
  });
};
CarouselList.Item = CarouselListItem;
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.41421 9.00008L8.70711 5.70718L7.29289 4.29297L2.29289 9.29297C1.90237 9.68349 1.90237 10.3167 2.29289 10.7072L7.29289 15.7072L8.70711 14.293L5.41421 11.0001H18V9.00008H5.41421Z",
  fill: "currentColor"
}));
const StyledCarouselActionsPrev = /* @__PURE__ */ createStyled("button", {
  target: "emqg2vg0"
})(({
  disabled
}) => {
  let styles = {
    border: "none",
    cursor: "pointer",
    width: "52px",
    height: "52px",
    padding: "16px",
    borderRadius: "100px",
    backgroundColor: "rgba(10, 11, 12, 0.9)",
    color: "rgba(255, 255, 255, 1)",
    ":hover": {
      opacity: 0.8
    }
  };
  if (disabled) {
    const disabledStyles = {
      backgroundColor: "rgba(10, 11, 12, 0.1)"
    };
    styles = merge(styles, disabledStyles);
  }
  return styles;
}, "");
const CarouselActionsPrev = ({
  className,
  children
}) => {
  const {
    isPrevSlideAvailable,
    onMoveToPrevSlide
  } = useCarouselContext();
  const handleMoveToPrevSlide = () => {
    onMoveToPrevSlide();
  };
  return /* @__PURE__ */ jsx(StyledCarouselActionsPrev, {
    type: "button",
    className,
    onClick: handleMoveToPrevSlide,
    disabled: !isPrevSlideAvailable,
    children: children || /* @__PURE__ */ jsx(SvgArrowLeft, {})
  });
};
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5858 9.00008L11.2929 5.70718L12.7071 4.29297L17.7071 9.29297C18.0976 9.68349 18.0976 10.3167 17.7071 10.7072L12.7071 15.7072L11.2929 14.293L14.5858 11.0001H2V9.00008H14.5858Z",
  fill: "currentColor"
}));
const StyledCarouselActionsNext = /* @__PURE__ */ createStyled("button", {
  target: "eldsqrn0"
})(({
  disabled
}) => {
  let styles = {
    border: "none",
    cursor: "pointer",
    width: "52px",
    height: "52px",
    padding: "16px",
    borderRadius: "100px",
    backgroundColor: "rgba(10, 11, 12, 0.9)",
    color: "rgba(255, 255, 255, 1)",
    ":hover": {
      opacity: 0.8
    }
  };
  if (disabled) {
    const disabledStyles = {
      backgroundColor: "rgba(10, 11, 12, 0.1)"
    };
    styles = merge(styles, disabledStyles);
  }
  return styles;
}, "");
const CarouselActionsNext = ({
  className,
  children
}) => {
  const {
    isNextSlideAvailable,
    onMoveToNextSlide
  } = useCarouselContext();
  const handleMoveToNextSlide = () => {
    onMoveToNextSlide();
  };
  return /* @__PURE__ */ jsx(StyledCarouselActionsNext, {
    type: "button",
    className,
    onClick: handleMoveToNextSlide,
    disabled: !isNextSlideAvailable,
    children: children || /* @__PURE__ */ jsx(SvgArrowRight, {})
  });
};
const StyledCarouselActions = /* @__PURE__ */ createStyled("div", {
  target: "e1okut020"
})(() => {
  return {
    display: "flex",
    gap: "16px"
  };
}, "");
const CarouselActions = ({
  className,
  children
}) => {
  return /* @__PURE__ */ jsx(StyledCarouselActions, {
    className,
    children
  });
};
CarouselActions.Prev = CarouselActionsPrev;
CarouselActions.Next = CarouselActionsNext;
const StyledCarousel = /* @__PURE__ */ createStyled("div", {
  target: "elrtlwk0"
})(() => {
  return {
    width: "100%",
    height: "100%",
    display: "flex",
    position: "relative",
    overflow: "hidden",
    flexDirection: "column"
  };
}, "");
const Carousel = ({
  length: length2,
  displayLength,
  gap = 0,
  children
}) => {
  const [slide, setSlide] = useState(0);
  const isAllSlidesDisplayedAtOnce = length2 <= displayLength;
  const isPrevSlideAvailable = !isAllSlidesDisplayedAtOnce && slide > 0;
  const isNextSlideAvailable = !isAllSlidesDisplayedAtOnce && slide + displayLength < length2;
  const handleMoveToPrevSlide = () => {
    setSlide((currentSlide) => {
      return currentSlide - 1;
    });
  };
  const handleMoveToNextSlide = () => {
    setSlide((currentSlide) => {
      return currentSlide + 1;
    });
  };
  return /* @__PURE__ */ jsx(StyledCarousel, {
    children: /* @__PURE__ */ jsx(CarouselContextProvider, {
      gap,
      slide,
      length: length2,
      displayLength,
      isPrevSlideAvailable,
      isNextSlideAvailable,
      onMoveToPrevSlide: handleMoveToPrevSlide,
      onMoveToNextSlide: handleMoveToNextSlide,
      children
    })
  });
};
Carousel.List = CarouselList;
Carousel.Actions = CarouselActions;
var DeviceSize = /* @__PURE__ */ ((DeviceSize2) => {
  DeviceSize2["MOBILE"] = "MOBILE";
  DeviceSize2["TABLET"] = "TABLET";
  DeviceSize2["DESKTOP"] = "DESKTOP";
  return DeviceSize2;
})(DeviceSize || {});
const useDeviceSize = () => {
  const [deviceSize, setDeviceSize] = useState("DESKTOP");
  useEffect(() => {
    const listener = () => {
      let nextDeviceSize = "DESKTOP";
      const tabletMedia = window.matchMedia("(max-width: 960px)");
      if (tabletMedia.matches) {
        nextDeviceSize = "TABLET";
      }
      const mobileMedia = window.matchMedia("(max-width: 480px)");
      if (mobileMedia.matches) {
        nextDeviceSize = "MOBILE";
      }
      if (nextDeviceSize !== deviceSize) {
        setDeviceSize(nextDeviceSize);
      }
    };
    window.addEventListener("resize", listener);
    return () => {
      return window.removeEventListener("resize", listener);
    };
  }, [deviceSize]);
  return deviceSize;
};
const Jobs$2 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const JobsWrapper = wrappers.jobs.wrapper;
  return /* @__PURE__ */ jsx(JobsWrapper, {
    id: SectionContainerId.JOBS_WRAPPER,
    children: /* @__PURE__ */ jsx("section", {
      className,
      children
    })
  });
};
const Caption$9 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const CaptionWrapper = wrappers.jobs.caption.wrapper;
  return /* @__PURE__ */ jsx(CaptionWrapper, {
    id: "jobs-caption-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "h2",
      children
    })
  });
};
const Container$f = /* @__PURE__ */ createStyled(Jobs$2, {
  target: "e1nmrrve14"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    caption
  } = templateStyles.jobs;
  return {
    backgroundColor,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 40px",
    "#jobs-caption-wrapper": {
      fontFamily: caption.fontFamily,
      fontWeight: caption.fontWeight,
      fontStyle: caption.fontStyle,
      fontSize: "40px",
      lineHeight: "131%"
    },
    [mq.sm]: {
      padding: "40px 24px"
    }
  };
}, "");
const Section$4 = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve13"
})(() => {
  return {
    width: "100%",
    maxWidth: "1110px",
    display: "flex",
    flexDirection: "column"
  };
}, "");
const Caption$8 = /* @__PURE__ */ createStyled(Caption$9, {
  target: "e1nmrrve12"
})(() => {
  return {
    width: "100%"
  };
}, "");
const JobsHeader = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve11"
})(() => {
  return {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "40px",
    [mq.md]: {
      flexDirection: "column",
      gap: "32px"
    }
  };
}, "");
const JobListItem$1 = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve10"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    borderRadius
  } = templateStyles.jobs.list.listItem;
  return {
    borderRadius,
    position: "relative",
    overflow: "hidden",
    height: "420px"
  };
}, "");
const JobListItemInfo = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve9"
})(() => {
  return {
    position: "absolute",
    left: 0,
    bottom: 0,
    height: "100%",
    width: "100%",
    padding: "32px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.15) 0%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0.75) 50%, rgba(0, 0, 0, 0.5) 100%)",
    backgroundSize: "200% 200%",
    backgroundPositionY: "0%",
    alignItems: "flex-start",
    justifyContent: "flex-end",
    transition: "all 200ms ease-out",
    ":hover": {
      justifyContent: "space-between",
      backgroundPositionY: "100%",
      [String(JobListItemInfoDescription)]: {
        display: "-webkit-box"
      },
      [String(BuyAction)]: {
        fontSize: "20px",
        borderRadius: "16px",
        padding: "12px 24px",
        [mq.md]: {
          fontSize: "16px",
          lineHeight: "150%",
          padding: "4px 12px",
          gap: "12px"
        }
      },
      [String(JobBuyButtonText)]: {
        display: "inline"
      },
      [String(JobBuyButtonDiv)]: {
        display: "block"
      },
      [String(JobBuyButtonPrice)]: {
        opacity: 0.75
      }
    },
    [mq.md]: {
      padding: "24px"
    }
  };
}, "");
const JobListItemInfoText = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve8"
})(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  };
}, "");
const JobListItemInfoTitle$1 = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve7"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    color,
    fontFamily,
    fontWeight,
    fontStyle
  } = templateStyles.jobs.list.listItem.title;
  return {
    color,
    fontFamily,
    fontWeight,
    fontStyle,
    fontSize: "24px",
    lineHeight: "150%",
    display: "-webkit-box",
    "-webkit-line-clamp": "2",
    "-webkit-box-orient": "vertical",
    overflow: "hidden"
  };
}, "");
const JobListItemInfoDescription = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve6"
})(() => {
  return {
    color: "#ffffff",
    fontSize: "18px",
    lineHeight: "150%",
    display: "none",
    "-webkit-line-clamp": "6",
    "-webkit-box-orient": "vertical",
    overflow: "hidden"
  };
}, "");
const BuyAction = /* @__PURE__ */ createStyled(Button, {
  target: "e1nmrrve4"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    fontStyle,
    fontWeight,
    color,
    backgroundColor,
    borderColor,
    transition,
    hover
  } = templateStyles.jobs.list.listItem.price.buyAction;
  return {
    fontStyle,
    color,
    fontWeight,
    backgroundColor,
    borderColor,
    transition,
    display: "flex",
    lineHeight: "150%",
    gap: "12px",
    borderRadius: "12px",
    padding: "4px 12px",
    ":hover": {
      ...hover
    }
  };
}, "");
const JobBuyButtonText = /* @__PURE__ */ createStyled("span", {
  target: "e1nmrrve3"
})(() => {
  return {
    display: "none"
  };
}, "");
const JobBuyButtonDiv = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve2"
})(() => {
  return {
    display: "none",
    width: "1px",
    height: "100%",
    backgroundColor: "rgba(255 ,255 ,255, 0.2)"
  };
}, "");
const JobBuyButtonPrice = /* @__PURE__ */ createStyled("span", {
  target: "e1nmrrve1"
})(() => {
  return {};
}, "");
const ListPlaceholder$3 = /* @__PURE__ */ createStyled("div", {
  target: "e1nmrrve0"
})(() => {
  return {
    marginTop: "40px",
    lineHeight: "150%",
    fontSize: "18px",
    fontWeight: 400
  };
}, "");
const MAP_CAROUSEL_SIZE_TO_DEVICE_SIZE = {
  [DeviceSize.MOBILE]: 1,
  [DeviceSize.TABLET]: 2,
  [DeviceSize.DESKTOP]: 3
};
const Jobs$1 = () => {
  const content = useContent();
  const handlers = useHandlers();
  const deviceSize = useDeviceSize();
  const {
    isVisible,
    caption,
    jobsList
  } = content.jobs;
  if (!isVisible) {
    return null;
  }
  const carouselLength = jobsList.length;
  const carouselDisplayLength = MAP_CAROUSEL_SIZE_TO_DEVICE_SIZE[deviceSize];
  if (carouselLength === 0) {
    return /* @__PURE__ */ jsx(Container$f, {
      children: /* @__PURE__ */ jsxs(Section$4, {
        children: [/* @__PURE__ */ jsx(Caption$8, {
          children: caption.value
        }), /* @__PURE__ */ jsx(ListPlaceholder$3, {
          children: "No items"
        })]
      })
    });
  }
  return /* @__PURE__ */ jsx(Container$f, {
    children: /* @__PURE__ */ jsx(Section$4, {
      children: /* @__PURE__ */ jsxs(Carousel, {
        length: carouselLength,
        displayLength: carouselDisplayLength,
        gap: 24,
        children: [/* @__PURE__ */ jsxs(JobsHeader, {
          children: [/* @__PURE__ */ jsx(Caption$8, {
            children: caption.value
          }), /* @__PURE__ */ jsxs(Carousel.Actions, {
            children: [/* @__PURE__ */ jsx(Carousel.Actions.Prev, {}), /* @__PURE__ */ jsx(Carousel.Actions.Next, {})]
          })]
        }), /* @__PURE__ */ jsx(Carousel.List, {
          children: jobsList.map(({
            id,
            image,
            title,
            description,
            price
          }) => {
            const handleClick = () => {
              handlers.jobs.onClick(id);
            };
            return /* @__PURE__ */ jsx(Carousel.List.Item, {
              children: /* @__PURE__ */ jsxs(JobListItem$1, {
                children: [/* @__PURE__ */ jsx(Image$2, {
                  src: image.value
                }), /* @__PURE__ */ jsxs(JobListItemInfo, {
                  children: [/* @__PURE__ */ jsxs(JobListItemInfoText, {
                    children: [/* @__PURE__ */ jsx(JobListItemInfoTitle$1, {
                      children: title
                    }), /* @__PURE__ */ jsx(JobListItemInfoDescription, {
                      children: description
                    })]
                  }), /* @__PURE__ */ jsxs(BuyAction, {
                    variant: ButtonVariant.CONTAINED,
                    onClick: handleClick,
                    children: [/* @__PURE__ */ jsx(JobBuyButtonText, {
                      children: "Buy"
                    }), /* @__PURE__ */ jsx(JobBuyButtonDiv, {}), /* @__PURE__ */ jsx(JobBuyButtonPrice, {
                      children: price
                    })]
                  })]
                })]
              })
            }, id);
          })
        })]
      })
    })
  });
};
const Skills$1 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const SkillsWrapper = wrappers.skills.wrapper;
  return /* @__PURE__ */ jsx(SkillsWrapper, {
    id: SectionContainerId.SKILLS_WRAPPER,
    children: /* @__PURE__ */ jsx("section", {
      className,
      children
    })
  });
};
const Caption$7 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const CaptionWrapper = wrappers.skills.caption.wrapper;
  return /* @__PURE__ */ jsx(CaptionWrapper, {
    id: "skills-caption-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "h2",
      children
    })
  });
};
const Container$e = /* @__PURE__ */ createStyled(Skills$1, {
  target: "e1g9mvch7"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    caption
  } = templateStyles.skills;
  return {
    backgroundColor,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 40px",
    [mq.md]: {
      padding: "40px 40px"
    },
    [mq.sm]: {
      padding: "32px 24px"
    },
    "#skills-caption-wrapper": {
      fontFamily: caption.fontFamily,
      fontWeight: caption.fontWeight,
      fontStyle: caption.fontStyle,
      fontSize: "40px",
      lineHeight: "131%"
    }
  };
}, "");
const Section$3 = /* @__PURE__ */ createStyled("div", {
  target: "e1g9mvch6"
})(() => {
  return {
    width: "100%",
    maxWidth: "1110px",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    [mq.lg]: {
      gap: "32px"
    }
  };
}, "");
const Caption$6 = /* @__PURE__ */ createStyled(Caption$7, {
  target: "e1g9mvch5"
})(() => {
  return {
    width: "100%"
  };
}, "");
const List$1 = /* @__PURE__ */ createStyled("ul", {
  target: "e1g9mvch4"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    boxShadow,
    borderRadius
  } = templateStyles.skills.list;
  return {
    backgroundColor,
    borderRadius,
    boxShadow,
    margin: 0,
    padding: "32px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    [mq.sm]: {
      padding: "24px",
      gap: "24px"
    }
  };
}, "");
const ListPlaceholder$2 = /* @__PURE__ */ createStyled("div", {
  target: "e1g9mvch3"
})(() => {
  return {
    lineHeight: "150%",
    fontSize: "18px",
    fontWeight: 400
  };
}, "");
const ListItem$1 = /* @__PURE__ */ createStyled("li", {
  target: "e1g9mvch2"
})(() => {
  return {
    display: "grid",
    gridTemplateColumns: "4fr 9fr",
    gridTemplateAreas: `
      "title description"
      `,
    gap: "32px",
    paddingBottom: "32px",
    borderBottom: "1px solid rgba(32, 32, 32, 0.1)",
    ":last-child": {
      paddingBottom: "0px",
      borderBottom: "none"
    },
    [mq.md]: {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto auto",
      gridTemplateAreas: `
        "title"
        "description"
        `,
      gap: "8px"
    },
    [mq.sm]: {
      paddingBottom: "24px"
    }
  };
}, "");
const Title$3 = /* @__PURE__ */ createStyled(Input, {
  target: "e1g9mvch1"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    fontFamily,
    fontWeight,
    fontStyle
  } = templateStyles.skills.list.listItem.title;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    fontSize: "18px",
    lineHeight: "150%",
    gridArea: "title"
  };
}, "");
const Description$3 = /* @__PURE__ */ createStyled(Input, {
  target: "e1g9mvch0"
})(() => {
  return {
    fontSize: "18px",
    lineHeight: "150%",
    gridArea: "description"
  };
}, "");
const Skills = () => {
  const content = useContent();
  const {
    isVisible,
    caption,
    skillsList
  } = content.skills;
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsx(Container$e, {
    children: /* @__PURE__ */ jsxs(Section$3, {
      children: [/* @__PURE__ */ jsx(Caption$6, {
        children: caption.value
      }), skillsList.length > 0 ? /* @__PURE__ */ jsx(List$1, {
        children: skillsList.map(({
          title,
          description
        }) => {
          return /* @__PURE__ */ jsxs(ListItem$1, {
            children: [/* @__PURE__ */ jsx(Title$3, {
              htmlTag: "h3",
              children: title
            }), /* @__PURE__ */ jsx(Description$3, {
              htmlTag: "p",
              children: description
            })]
          }, title);
        })
      }) : /* @__PURE__ */ jsx(ListPlaceholder$2, {
        children: "No items"
      })]
    })
  });
};
const Experience$1 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const ExperienceWrapper = wrappers.experience.wrapper;
  return /* @__PURE__ */ jsx(ExperienceWrapper, {
    id: SectionContainerId.EXPERIENCE_WRAPPER,
    children: /* @__PURE__ */ jsx("section", {
      className,
      children
    })
  });
};
const Caption$5 = ({
  className,
  children
}) => {
  const wrappers = useWrappers();
  const CaptionWrapper = wrappers.experience.caption.wrapper;
  return /* @__PURE__ */ jsx(CaptionWrapper, {
    id: "experience-caption-wrapper",
    children: /* @__PURE__ */ jsx(Input, {
      className,
      htmlTag: "h2",
      children
    })
  });
};
const Container$d = /* @__PURE__ */ createStyled(Experience$1, {
  target: "etz0r3q10"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    caption
  } = templateStyles.experience;
  return {
    backgroundColor,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 40px",
    [mq.md]: {
      padding: "40px 40px"
    },
    [mq.sm]: {
      padding: "32px 24px"
    },
    "#experience-caption-wrapper": {
      fontFamily: caption.fontFamily,
      fontWeight: caption.fontWeight,
      fontStyle: caption.fontStyle,
      fontSize: "40px",
      lineHeight: "131%"
    }
  };
}, "");
const Section$2 = /* @__PURE__ */ createStyled("div", {
  target: "etz0r3q9"
})(() => {
  return {
    width: "100%",
    maxWidth: "1110px",
    display: "flex",
    flexDirection: "column",
    gap: "40px",
    [mq.lg]: {
      gap: "32px"
    }
  };
}, "");
const Caption$4 = /* @__PURE__ */ createStyled(Caption$5, {
  target: "etz0r3q8"
})(() => {
  return {
    width: "100%"
  };
}, "");
const List = /* @__PURE__ */ createStyled("ul", {
  target: "etz0r3q7"
})(() => {
  return {
    margin: 0,
    padding: 0,
    paddingTop: "32px",
    borderTop: "1px solid rgba(32, 32, 32, 0.3)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    [mq.sm]: {
      gap: "24px"
    }
  };
}, "");
const ListPlaceholder$1 = /* @__PURE__ */ createStyled("div", {
  target: "etz0r3q6"
})(() => {
  return {
    lineHeight: "150%",
    fontSize: "18px",
    fontWeight: 400
  };
}, "");
const ListItem = /* @__PURE__ */ createStyled("li", {
  target: "etz0r3q5"
})(() => {
  return {
    display: "grid",
    gridTemplateColumns: "4fr 5fr 3fr",
    gridTemplateAreas: `
      "position description period"
      `,
    gap: "32px",
    paddingBottom: "32px",
    borderBottom: "1px solid rgba(32, 32, 32, 0.1)",
    ":last-child": {
      borderBottom: "none"
    },
    [mq.lg]: {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto auto auto",
      gridTemplateAreas: `
      "position" 
      "description"
      "period"
      `,
      gap: "8px"
    }
  };
}, "");
const PosOrgGroup = /* @__PURE__ */ createStyled("div", {
  target: "etz0r3q4"
})(() => {
  return {
    gridArea: "position",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    [mq.lg]: {
      gap: "0"
    }
  };
}, "");
const Position = /* @__PURE__ */ createStyled(Input, {
  target: "etz0r3q3"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    fontFamily,
    fontWeight,
    fontStyle
  } = templateStyles.experience.list.listItem.position;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    fontSize: "18px",
    lineHeight: "150%",
    [mq.lg]: {
      fontSize: "22px"
    }
  };
}, "");
const Organization = /* @__PURE__ */ createStyled(Input, {
  target: "etz0r3q2"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    color
  } = templateStyles.experience.list.listItem.organization;
  return {
    color,
    fontSize: "18px",
    lineHeight: "150%",
    [mq.lg]: {
      fontSize: "16px"
    }
  };
}, "");
const Description$2 = /* @__PURE__ */ createStyled(Input, {
  target: "etz0r3q1"
})(() => {
  return {
    gridArea: "description",
    fontSize: "18px",
    lineHeight: "150%"
  };
}, "");
const Period = /* @__PURE__ */ createStyled(Input, {
  target: "etz0r3q0"
})(() => {
  return {
    gridArea: "period",
    fontSize: "18px",
    lineHeight: "27px",
    textAlign: "right",
    [mq.lg]: {
      textAlign: "left"
    }
  };
}, "");
const Experience = () => {
  const content = useContent();
  const {
    isVisible,
    caption,
    experienceList
  } = content.experience;
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsx(Container$d, {
    children: /* @__PURE__ */ jsxs(Section$2, {
      children: [/* @__PURE__ */ jsx(Caption$4, {
        children: caption.value
      }), experienceList.length > 0 ? /* @__PURE__ */ jsx(List, {
        children: experienceList.map(({
          position: position2,
          organization,
          description,
          startDate,
          endDate,
          isCurrent
        }) => {
          return /* @__PURE__ */ jsxs(ListItem, {
            children: [/* @__PURE__ */ jsxs(PosOrgGroup, {
              children: [/* @__PURE__ */ jsx(Position, {
                htmlTag: "h3",
                children: position2
              }), /* @__PURE__ */ jsx(Organization, {
                htmlTag: "h4",
                children: organization
              })]
            }), /* @__PURE__ */ jsx(Description$2, {
              htmlTag: "p",
              children: description
            }), /* @__PURE__ */ jsx(Period, {
              children: `${startDate} - ${isCurrent ? "Present" : endDate}`
            })]
          }, `${position2}-${organization}`);
        })
      }) : /* @__PURE__ */ jsx(ListPlaceholder$1, {
        children: "No items"
      })]
    })
  });
};
const Container$c = /* @__PURE__ */ createStyled("div", {
  target: "eyeh0mt10"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    color
  } = templateStyles.availability;
  return {
    color,
    backgroundColor,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "120px 40px",
    [mq.lg]: {
      padding: "80px 40px"
    },
    [mq.md]: {
      padding: "40px 40px"
    },
    [mq.sm]: {
      padding: "40px 24px"
    }
  };
}, "");
const Content$4 = /* @__PURE__ */ createStyled("div", {
  target: "eyeh0mt9"
})(() => {
  return {
    width: "100%",
    maxWidth: "1110px",
    display: "grid",
    gridTemplateColumns: "4fr 5fr 3fr",
    gridTemplateAreas: `
      "caption contacts booking"
      `,
    alignItems: "start",
    gap: "32px",
    [mq.lg]: {
      gridTemplateColumns: "1fr 2fr",
      gridTemplateRows: "auto auto",
      gridTemplateAreas: `
        "caption booking" 
        ". contacts"
        `,
      gap: "16px"
    },
    [mq.md]: {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto auto auto",
      gridTemplateAreas: `
        "caption" 
        "booking" 
        "contacts"
        `
    }
  };
}, "");
const Caption$3 = /* @__PURE__ */ createStyled("div", {
  target: "eyeh0mt8"
})(() => {
  return {
    gridArea: "caption",
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  };
}, "");
const Name$2 = /* @__PURE__ */ createStyled(Input, {
  target: "eyeh0mt7"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    fontFamily,
    fontWeight,
    fontStyle
  } = templateStyles.availability.caption.name;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    fontSize: "18px",
    lineHeight: "150%",
    [mq.sm]: {
      fontSize: "22px"
    }
  };
}, "");
const Title$2 = /* @__PURE__ */ createStyled(Input, {
  target: "eyeh0mt6"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    color
  } = templateStyles.availability.caption.title;
  return {
    color,
    fontSize: "16px",
    lineHeight: "150%"
  };
}, "");
const Contacts$2 = /* @__PURE__ */ createStyled("div", {
  target: "eyeh0mt5"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    borderRadius,
    boxShadow
  } = templateStyles.availability.contacts;
  return {
    gridArea: "contacts",
    borderRadius,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    [mq.lg]: {
      boxShadow,
      padding: "16px 24px",
      gap: "12px"
    },
    [mq.sm]: {
      padding: "16px"
    }
  };
}, "");
const ContactsGroup = /* @__PURE__ */ createStyled("div", {
  target: "eyeh0mt4"
})(() => {
  return {
    display: "flex",
    [mq.sm]: {
      flexDirection: "column",
      gap: "8px"
    }
  };
}, "");
const ContactsLabel = /* @__PURE__ */ createStyled("label", {
  target: "eyeh0mt3"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    color
  } = templateStyles.availability.contacts.label;
  return {
    color,
    fontSize: "16px",
    lineHeight: "150%",
    width: "80px",
    marginRight: "12px",
    flexShrink: "0"
  };
}, "");
const ContactsValue = /* @__PURE__ */ createStyled(Input, {
  target: "eyeh0mt2"
})(() => {
  return {
    fontSize: "16px",
    lineHeight: "150%"
  };
}, "");
const Booking = /* @__PURE__ */ createStyled("div", {
  target: "eyeh0mt1"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    borderRadius,
    boxShadow
  } = templateStyles.availability.booking;
  return {
    gridArea: "booking",
    boxShadow,
    borderRadius,
    padding: "16px 24px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    "> span": {
      lineHeight: "150%"
    },
    [mq.sm]: {
      padding: "16px"
    }
  };
}, "");
const BookMe = /* @__PURE__ */ createStyled(PrimaryAction$5, {
  target: "eyeh0mt0"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    color,
    fontFamily,
    fontWeight,
    fontStyle
  } = templateStyles.availability.booking.bookMe;
  return {
    color,
    fontFamily,
    fontWeight,
    fontStyle,
    padding: 0,
    backgroundColor: "transparent",
    border: "none",
    lineHeight: "150%",
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: 0.7
    }
  };
}, "");
const Availability = () => {
  const content = useContent();
  const {
    name,
    title
  } = content.hero;
  const {
    phone,
    email,
    address,
    availability
  } = content.contacts;
  return /* @__PURE__ */ jsx(Container$c, {
    children: /* @__PURE__ */ jsxs(Content$4, {
      children: [/* @__PURE__ */ jsxs(Caption$3, {
        children: [/* @__PURE__ */ jsx(Name$2, {
          children: name.value
        }), /* @__PURE__ */ jsx(Title$2, {
          children: title.value
        })]
      }), /* @__PURE__ */ jsxs(Contacts$2, {
        children: [email.isVisible ? /* @__PURE__ */ jsxs(ContactsGroup, {
          children: [/* @__PURE__ */ jsx(ContactsLabel, {
            children: "Email"
          }), /* @__PURE__ */ jsx(ContactsValue, {
            children: email.value
          })]
        }) : null, phone.isVisible ? /* @__PURE__ */ jsxs(ContactsGroup, {
          children: [/* @__PURE__ */ jsx(ContactsLabel, {
            children: "Phone"
          }), /* @__PURE__ */ jsx(ContactsValue, {
            children: phone.value
          })]
        }) : null, address.isVisible ? /* @__PURE__ */ jsxs(ContactsGroup, {
          children: [/* @__PURE__ */ jsx(ContactsLabel, {
            children: "Address"
          }), /* @__PURE__ */ jsx(ContactsValue, {
            children: address.value
          })]
        }) : null]
      }), /* @__PURE__ */ jsxs(Booking, {
        children: [/* @__PURE__ */ jsx(Input, {
          children: availability.isAvailable ? "Available Now" : "Not Available Now"
        }), /* @__PURE__ */ jsx(BookMe, {
          variant: ButtonVariant.OUTLINED,
          children: "Book me"
        })]
      })]
    })
  });
};
const Container$b = /* @__PURE__ */ createStyled("footer", {
  target: "ephknw13"
})(() => {
  const templateStyles = useTemplateStyles$2();
  const {
    backgroundColor,
    color
  } = templateStyles.footer;
  return {
    color,
    backgroundColor,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "48px 40px",
    [mq.md]: {
      padding: "32px 40px"
    },
    [mq.sm]: {
      padding: "24px"
    }
  };
}, "");
const Content$3 = /* @__PURE__ */ createStyled("div", {
  target: "ephknw12"
})(() => {
  return {
    maxWidth: "1110px",
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 2fr 1fr",
    alignItems: "center",
    gap: "32px",
    p: {
      lineHeight: "150%"
    },
    [mq.lg]: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      alignItems: "center"
    }
  };
}, "");
const SocialsList$1 = /* @__PURE__ */ createStyled("div", {
  target: "ephknw11"
})(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "32px",
    "> a": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "40px",
      height: "40px",
      transition: "transform 100ms ease-in",
      ":hover": {
        transform: "scale(1.2)"
      }
    },
    [mq.md]: {
      width: "100%",
      gap: "12px",
      justifyContent: "space-around"
    }
  };
}, "");
const PoweredByWorkee$2 = /* @__PURE__ */ createStyled(Input, {
  target: "ephknw10"
})(() => {
  return {
    justifySelf: "end",
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: 0.7
    }
  };
}, "");
const MAP_SOCIAL_TO_ICON$2 = {
  [Social.linkedIn]: SvgLinkedIn,
  [Social.youTube]: SvgYoutube,
  [Social.facebook]: SvgFacebook,
  [Social.twitter]: SvgTwitter,
  [Social.instagram]: SvgInstagram,
  [Social.tikTok]: SvgTikTok,
  [Social.telegram]: SvgTelegram
};
const Footer$2 = () => {
  const content = useContent();
  const {
    name
  } = content.hero;
  const {
    socials
  } = content.contacts;
  const currentYear = new Date().getFullYear();
  const renderSocialContacts = () => {
    return Object.values(socials).map((social) => {
      var _a;
      const SocialContactIcon = (_a = MAP_SOCIAL_TO_ICON$2[social.id]) != null ? _a : Fragment;
      if (social.isVisible) {
        return /* @__PURE__ */ jsx(Link, {
          href: social.value,
          children: /* @__PURE__ */ jsx(SocialContactIcon, {})
        }, social.id);
      }
      return null;
    });
  };
  return /* @__PURE__ */ jsx(Container$b, {
    children: /* @__PURE__ */ jsxs(Content$3, {
      children: [/* @__PURE__ */ jsx(Input, {
        htmlTag: "p",
        children: `${currentYear} \xA9 ${name.value}`
      }), /* @__PURE__ */ jsx(SocialsList$1, {
        children: renderSocialContacts()
      }), /* @__PURE__ */ jsx(PoweredByWorkee$2, {
        htmlTag: "p",
        children: /* @__PURE__ */ jsx(Link, {
          href: "https://workee.net",
          children: "Powered by Workee"
        })
      })]
    })
  });
};
const Container$a = /* @__PURE__ */ createStyled("div", {
  target: "e45d5ig1"
})(() => {
  return {};
}, "");
const Sections = /* @__PURE__ */ createStyled("div", {
  target: "e45d5ig0"
})(() => {
  return {
    "> div:last-of-type": {
      section: {
        paddingBottom: "120px"
      }
    },
    [mq.lg]: {
      "> div:last-of-type": {
        section: {
          paddingBottom: "64px"
        }
      }
    },
    [mq.sm]: {
      "> div:last-of-type": {
        section: {
          paddingBottom: "24px"
        }
      }
    }
  };
}, "");
const Basic = () => {
  const theme = useTheme();
  const content = useContent();
  return /* @__PURE__ */ jsx(TemplateStylesProvider$2, {
    theme,
    content,
    children: /* @__PURE__ */ jsxs(Container$a, {
      children: [/* @__PURE__ */ jsx(Header$1, {}), /* @__PURE__ */ jsx(Hero$2, {}), /* @__PURE__ */ jsx(Contacts$3, {}), /* @__PURE__ */ jsxs(Sections, {
        children: [/* @__PURE__ */ jsx(About$1, {}), /* @__PURE__ */ jsx(Jobs$1, {}), /* @__PURE__ */ jsx(Skills, {}), /* @__PURE__ */ jsx(Experience, {})]
      }), /* @__PURE__ */ jsx(Availability, {}), /* @__PURE__ */ jsx(Footer$2, {})]
    })
  });
};
const generateActionStyles$1 = (theme, variant) => {
  if (variant === ButtonVariant.CONTAINED) {
    return {
      fontFamily: theme.fonts.primary.fontFamily,
      fontWeight: theme.fonts.primary.fontWeight,
      fontStyle: theme.fonts.primary.fontStyle,
      color: "#000",
      backgroundColor: "#fff",
      borderColor: "#fff",
      borderRadius: "8px"
    };
  }
  if (variant === ButtonVariant.OUTLINED) {
    return {
      fontFamily: theme.fonts.primary.fontFamily,
      fontWeight: theme.fonts.primary.fontWeight,
      fontStyle: theme.fonts.primary.fontStyle,
      color: "#fff",
      backgroundColor: "transparent",
      borderColor: "#fff",
      borderRadius: "8px"
    };
  }
  return {
    fontFamily: theme.fonts.primary.fontFamily,
    fontWeight: theme.fonts.primary.fontWeight,
    fontStyle: theme.fonts.primary.fontStyle,
    color: "#000",
    backgroundColor: "#fff",
    borderColor: "#fff",
    borderRadius: "8px"
  };
};
const generateTemplateStyles$1 = (theme, content) => {
  return {
    header: {
      logoText: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle,
        color: theme.colors.primary
      }
    },
    hero: {
      backgroundColor: theme.colors.primary,
      name: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      title: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      image: {
        borderRadius: "64px"
      },
      primaryAction: generateActionStyles$1(theme, content.hero.primaryAction.variant),
      secondaryAction: generateActionStyles$1(theme, content.hero.secondaryAction.variant)
    },
    contacts: {
      caption: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      }
    },
    jobs: {
      caption: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      list: {
        title: {
          fontFamily: theme.fonts.primary.fontFamily,
          fontWeight: theme.fonts.primary.fontWeight,
          fontStyle: theme.fonts.primary.fontStyle
        },
        photo: {
          borderRadius: "8px"
        },
        borderRadius: "16px",
        color: theme.colors.primary
      }
    },
    about: {
      caption: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      image: {
        borderRadius: "24px"
      }
    }
  };
};
const TemplateStylesContext$1 = createContext(generateTemplateStyles$1(getDefaultTheme(), getDefaultContent()));
const TemplateStylesProvider$1 = ({
  theme,
  content,
  children
}) => {
  const value = useMemo(() => {
    return generateTemplateStyles$1(theme, content);
  }, [theme, content]);
  return /* @__PURE__ */ jsx(TemplateStylesContext$1.Provider, {
    value,
    children
  });
};
const useTemplateStyles$1 = () => {
  return useContext(TemplateStylesContext$1);
};
const Container$9 = /* @__PURE__ */ createStyled(Header$2, {
  target: "em4iuah2"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    logoText
  } = templateStyles.header;
  return {
    padding: "32px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",
    alignItems: "stretch",
    textAlignLast: "right",
    textAlign: "right",
    marginLeft: "auto",
    maxWidth: "360px",
    [mq.lg]: {
      position: "absolute",
      width: "100%",
      maxWidth: "864px",
      top: 0,
      justifyContent: "flex-start",
      gridArea: "header",
      padding: "24px 32px",
      height: "80px",
      textAlignLast: "left"
    },
    [mq.sm]: {
      padding: "24px"
    },
    "#header-logoText-wrapper": {
      fontFamily: logoText.fontFamily,
      fontWeight: logoText.fontWeight,
      fontStyle: logoText.fontStyle,
      color: logoText.color,
      fontSize: "24px",
      lineHeight: "150%"
    }
  };
}, "");
const LogoText = /* @__PURE__ */ createStyled(LogoText$2, {
  target: "em4iuah1"
})(() => {
  return {};
}, "");
const LogoImage = /* @__PURE__ */ createStyled(LogoImage$2, {
  target: "em4iuah0"
})(() => {
  return {
    height: "32px",
    objectFit: "cover",
    width: "auto"
  };
}, "");
const Header = () => {
  const content = useContent();
  const {
    logoText,
    logoImage,
    logoDisplayVariant
  } = content.header;
  return /* @__PURE__ */ jsxs(Container$9, {
    children: [logoDisplayVariant === LogoDisplayVariant.TEXT ? /* @__PURE__ */ jsx(LogoText, {
      children: logoText.value
    }) : null, logoDisplayVariant === LogoDisplayVariant.IMAGE ? /* @__PURE__ */ jsx(LogoImage, {
      src: logoImage.value,
      alt: "logo"
    }) : null]
  });
};
const Container$8 = /* @__PURE__ */ createStyled(Hero$3, {
  target: "e1hjwo0b10"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    backgroundColor,
    name,
    title
  } = templateStyles.hero;
  return {
    backgroundColor,
    height: "100%",
    [mq.lg]: {
      padding: "32px"
    },
    [mq.sm]: {
      padding: "32px 24px"
    },
    "#hero-name-wrapper": {
      fontFamily: name.fontFamily,
      fontStyle: name.fontStyle,
      fontWeight: name.fontWeight,
      fontSize: "24px",
      lineHeight: "150%",
      color: "#fff",
      [mq.lg]: {
        fontSize: "32px"
      },
      [mq.md]: {
        fontSize: "24px",
        lineHeight: "130%"
      }
    },
    "#hero-title-wrapper": {
      fontFamily: title.fontFamily,
      fontStyle: title.fontStyle,
      fontWeight: title.fontWeight,
      fontSize: "16px",
      lineHeight: "130%",
      color: "#fff"
    }
  };
}, "");
const Body$4 = /* @__PURE__ */ createStyled("div", {
  target: "e1hjwo0b9"
})(() => {
  return {
    height: "100%",
    display: "grid",
    gridTemplateColumns: "auto",
    gridTemplateRows: "1fr 2fr 1fr",
    gridTemplateAreas: `
      "text"
      "image"
      "actions"
      `,
    alignItems: "center",
    gap: "16px",
    position: "relative",
    zIndex: 2,
    "#hero-image-wrapper": {
      gridArea: "image",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflowX: "hidden",
      overflowY: "auto",
      minWidth: 0,
      minHeight: 0,
      height: "100%",
      padding: "0 24px"
    },
    [mq.lg]: {
      width: "100%",
      maxWidth: "800px",
      margin: "0 auto",
      gridTemplateRows: "auto auto",
      gridTemplateColumns: "245px auto",
      gridTemplateAreas: `
        "image text"
        "image actions"
        `,
      columnGap: "32px",
      rowGap: "0",
      "#hero-image-wrapper": {
        padding: 0
      }
    },
    [mq.md]: {
      gridTemplateColumns: "96px auto",
      gridTemplateAreas: `
        "image text"
        "actions actions"
        `,
      gap: "24px"
    }
  };
}, "");
const BGBlur$1 = /* @__PURE__ */ createStyled("div", {
  target: "e1hjwo0b8"
})(() => {
  return {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    zIndex: 1,
    overflow: "hidden"
  };
}, "");
const BGBlurImage$1 = /* @__PURE__ */ createStyled("img", {
  target: "e1hjwo0b7"
})(() => {
  return {
    width: "100%",
    height: "100%",
    filter: "blur(32px)",
    mixBlendMode: "luminosity",
    opacity: 0.3
  };
}, "");
const TextContainer$1 = /* @__PURE__ */ createStyled("article", {
  target: "e1hjwo0b6"
})(() => {
  return {
    gridArea: "text",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: "8px",
    textAlign: "center",
    textAlignLast: "center",
    padding: "0 24px",
    [mq.lg]: {
      alignSelf: "end",
      textAlign: "left",
      textAlignLast: "left",
      padding: 0
    },
    [mq.md]: {
      alignSelf: "center"
    }
  };
}, "");
const Name$1 = /* @__PURE__ */ createStyled(Name$4, {
  target: "e1hjwo0b5"
})(() => {
  return {};
}, "");
const Title$1 = /* @__PURE__ */ createStyled(Title$5, {
  target: "e1hjwo0b4"
})(() => {
  return {};
}, "");
const HeroImage$1 = /* @__PURE__ */ createStyled(Image$1, {
  target: "e1hjwo0b3"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    borderRadius
  } = templateStyles.hero.image;
  return {
    borderRadius,
    objectFit: "cover",
    aspectRatio: "1 / 1",
    minWidth: 0,
    minHeight: 0,
    width: "auto",
    height: "100%",
    [mq.lg]: {
      width: "245px",
      height: "245px",
      maxWidth: "unset"
    },
    [mq.md]: {
      borderRadius: "24px",
      width: "104px",
      height: "104px"
    }
  };
}, "");
const Actions$1 = /* @__PURE__ */ createStyled("div", {
  target: "e1hjwo0b2"
})(() => {
  return {
    gridArea: "actions",
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    [mq.lg]: {
      alignItems: "flex-start",
      justifyContent: "start",
      alignSelf: "start",
      marginTop: "24px"
    },
    [mq.md]: {
      marginTop: 0
    }
  };
}, "");
const PrimaryAction$1 = /* @__PURE__ */ createStyled(PrimaryAction$3, {
  target: "e1hjwo0b1"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius
  } = templateStyles.hero.primaryAction;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius,
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: 0.8
    }
  };
}, "");
const SecondaryAction$1 = /* @__PURE__ */ createStyled(SecondaryAction$3, {
  target: "e1hjwo0b0"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius
  } = templateStyles.hero.secondaryAction;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius,
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: 0.8
    }
  };
}, "");
const Hero$1 = () => {
  const content = useContent();
  const {
    name,
    title,
    image,
    primaryAction,
    secondaryAction
  } = content.hero;
  return /* @__PURE__ */ jsxs(Container$8, {
    children: [/* @__PURE__ */ jsxs(Body$4, {
      children: [/* @__PURE__ */ jsxs(TextContainer$1, {
        children: [/* @__PURE__ */ jsx(Name$1, {
          children: name.value
        }), /* @__PURE__ */ jsx(Title$1, {
          children: title.value
        })]
      }), /* @__PURE__ */ jsx(HeroImage$1, {
        src: image.value,
        alt: name.value
      }), /* @__PURE__ */ jsxs(Actions$1, {
        children: [/* @__PURE__ */ jsx(PrimaryAction$1, {
          variant: primaryAction.variant,
          children: primaryAction.value
        }), /* @__PURE__ */ jsx(SecondaryAction$1, {
          variant: secondaryAction.variant,
          children: secondaryAction.value
        })]
      })]
    }), /* @__PURE__ */ jsx(BGBlur$1, {
      children: /* @__PURE__ */ jsx(BGBlurImage$1, {
        src: image.value,
        alt: name.value
      })
    })]
  });
};
const Container$7 = /* @__PURE__ */ createStyled(Jobs$2, {
  target: "ecphjia8"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    caption
  } = templateStyles.jobs;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    padding: "60px 40px",
    "#jobs-caption-wrapper": {
      fontFamily: caption.fontFamily,
      fontWeight: caption.fontWeight,
      fontStyle: caption.fontStyle,
      fontSize: "32px",
      lineHeight: "131%"
    },
    [mq.sm]: {
      padding: "40px 24px"
    }
  };
}, "");
const Section$1 = /* @__PURE__ */ createStyled("div", {
  target: "ecphjia7"
})(() => {
  return {
    width: "100%",
    maxWidth: "656px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    [mq.lg]: {
      maxWidth: "800px"
    }
  };
}, "");
const Caption$2 = /* @__PURE__ */ createStyled(Caption$9, {
  target: "ecphjia6"
})(() => {
  return {
    width: "100%",
    fontSize: "32px",
    lineHeight: "131%"
  };
}, "");
const JobList = /* @__PURE__ */ createStyled("span", {
  target: "ecphjia5"
})(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  };
}, "");
const JobListItem = /* @__PURE__ */ createStyled("div", {
  target: "ecphjia4"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    borderRadius
  } = templateStyles.jobs.list;
  return {
    borderRadius,
    display: "flex",
    gap: "16px",
    alignItems: "center",
    padding: "12px 16px",
    border: "1px solid rgba(10, 11, 12, 0.1)",
    transition: "transform 150ms ease-in, box-shadow 150ms ease-in",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 4px 12px 0px rgb(32, 32, 32, 0.1)",
      zIndex: 1
    },
    [mq.sm]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px"
    }
  };
}, "");
const JobListItemPhoto = /* @__PURE__ */ createStyled("div", {
  target: "ecphjia3"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    borderRadius
  } = templateStyles.jobs.list.photo;
  return {
    borderRadius,
    width: "48px",
    height: "48px",
    overflow: "hidden",
    flexShrink: "0"
  };
}, "");
const JobListItemInfoTitle = /* @__PURE__ */ createStyled("div", {
  target: "ecphjia2"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    fontFamily,
    fontWeight,
    fontStyle
  } = templateStyles.jobs.list.title;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color: "#000",
    fontSize: "20px",
    lineHeight: "150%",
    flexGrow: "1"
  };
}, "");
const JobPrice = /* @__PURE__ */ createStyled("div", {
  target: "ecphjia1"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    color
  } = templateStyles.jobs.list;
  return {
    color,
    fontSize: "18px",
    lineHeight: "150%",
    borderRadius: "12px",
    wordBreak: "keep-all"
  };
}, "");
const ListPlaceholder = /* @__PURE__ */ createStyled("div", {
  target: "ecphjia0"
})(() => {
  return {
    marginTop: "16px",
    lineHeight: "150%",
    fontSize: "18px",
    fontWeight: 400
  };
}, "");
const Jobs = () => {
  const content = useContent();
  const handlers = useHandlers();
  const {
    isVisible,
    caption,
    jobsList
  } = content.jobs;
  if (!isVisible) {
    return null;
  }
  if (jobsList.length === 0) {
    return /* @__PURE__ */ jsx(Container$7, {
      children: /* @__PURE__ */ jsxs(Section$1, {
        children: [/* @__PURE__ */ jsx(Caption$2, {
          children: caption.value
        }), /* @__PURE__ */ jsx(ListPlaceholder, {
          children: "No items"
        })]
      })
    });
  }
  return /* @__PURE__ */ jsx(Container$7, {
    children: /* @__PURE__ */ jsxs(Section$1, {
      children: [/* @__PURE__ */ jsx(Caption$2, {
        children: caption.value
      }), /* @__PURE__ */ jsx(JobList, {
        children: jobsList.map(({
          id,
          image,
          title,
          price
        }) => {
          const handleClick = () => {
            handlers.jobs.onClick(id);
          };
          return /* @__PURE__ */ jsxs(JobListItem, {
            onClick: handleClick,
            children: [/* @__PURE__ */ jsx(JobListItemPhoto, {
              children: /* @__PURE__ */ jsx(Image$2, {
                src: image.value
              })
            }), /* @__PURE__ */ jsx(JobListItemInfoTitle, {
              children: title
            }), /* @__PURE__ */ jsx(JobPrice, {
              children: price
            })]
          }, id);
        })
      })]
    })
  });
};
const Container$6 = /* @__PURE__ */ createStyled(About$2, {
  target: "e80julg5"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    caption
  } = templateStyles.about;
  return {
    display: "flex",
    justifyContent: "center",
    padding: "0 32px",
    [mq.lg]: {
      paddingTop: "40px"
    },
    [mq.sm]: {
      padding: "0 24px",
      paddingTop: "32px"
    },
    "#about-caption-wrapper": {
      fontFamily: caption.fontFamily,
      fontWeight: caption.fontWeight,
      fontStyle: caption.fontStyle,
      fontSize: "32px",
      lineHeight: "131%",
      [mq.sm]: {
        fontSize: "24px"
      }
    },
    "#about-description-wrapper": {
      fontSize: "18px",
      lineHeight: "150%"
    }
  };
}, "");
const Body$3 = /* @__PURE__ */ createStyled("div", {
  target: "e80julg4"
})(() => {
  return {
    display: "flex",
    flexDirection: "column",
    maxWidth: "656px",
    width: "100%",
    gap: "32px",
    [mq.lg]: {
      maxWidth: "800px"
    },
    [mq.sm]: {
      gap: "24px"
    }
  };
}, "");
const Caption$1 = /* @__PURE__ */ createStyled(Caption$b, {
  target: "e80julg3"
})(() => {
  return {};
}, "");
const Content$2 = /* @__PURE__ */ createStyled("div", {
  target: "e80julg2"
})(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    [mq.sm]: {
      gap: "24px"
    }
  };
}, "");
const Description$1 = /* @__PURE__ */ createStyled(Description$5, {
  target: "e80julg1"
})(() => {
  return {};
}, "");
const UserImage = /* @__PURE__ */ createStyled(Image, {
  target: "e80julg0"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    borderRadius
  } = templateStyles.about.image;
  return {
    borderRadius
  };
}, "");
const About = () => {
  const content = useContent();
  const {
    isVisible,
    caption,
    description,
    image
  } = content.about;
  if (!isVisible) {
    return null;
  }
  return /* @__PURE__ */ jsx(Container$6, {
    children: /* @__PURE__ */ jsxs(Body$3, {
      children: [/* @__PURE__ */ jsx(Caption$1, {
        children: caption.value
      }), /* @__PURE__ */ jsxs(Content$2, {
        children: [/* @__PURE__ */ jsx(Description$1, {
          children: description.value
        }), /* @__PURE__ */ jsx(UserImage, {
          src: image.value,
          alt: "me"
        })]
      })]
    })
  });
};
const SvgAddress = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23.1875C12 23.1875 21 18.6875 21 10.8125C21 5.84194 16.9706 1.8125 12 1.8125C7.02944 1.8125 3 5.84194 3 10.8125C3 18.6875 12 23.1875 12 23.1875ZM12 14.1875C13.864 14.1875 15.375 12.6765 15.375 10.8125C15.375 8.94854 13.864 7.4375 12 7.4375C10.136 7.4375 8.625 8.94854 8.625 10.8125C8.625 12.6765 10.136 14.1875 12 14.1875Z",
  fill: "currentColor"
}));
const Container$5 = /* @__PURE__ */ createStyled(Contacts$4, {
  target: "e7d5sbs8"
})(() => {
  return {
    display: "flex",
    justifyContent: "center",
    padding: "0 32px",
    marginTop: "56px",
    [mq.sm]: {
      padding: "0 24px",
      marginTop: "40px"
    }
  };
}, "");
const Body$2 = /* @__PURE__ */ createStyled("div", {
  target: "e7d5sbs7"
})(() => {
  return {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "656px",
    gap: "32px",
    [mq.lg]: {
      maxWidth: "800px"
    },
    [mq.sm]: {
      gap: "24px"
    }
  };
}, "");
const Caption = /* @__PURE__ */ createStyled("div", {
  target: "e7d5sbs6"
})(() => {
  const templateStyles = useTemplateStyles$1();
  const {
    fontFamily,
    fontWeight,
    fontStyle
  } = templateStyles.contacts.caption;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    fontSize: "32px",
    lineHeight: "131%",
    [mq.sm]: {
      fontSize: "24px"
    }
  };
}, "");
const ContactsList = /* @__PURE__ */ createStyled("ul", {
  target: "e7d5sbs5"
})(() => {
  return {
    padding: 0,
    margin: 0,
    listStyle: "none",
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
    [mq.sm]: {
      gap: "4px"
    }
  };
}, "");
const ContactsListItem = /* @__PURE__ */ createStyled("li", {
  target: "e7d5sbs4"
})(() => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "> *": {
      border: "1px solid rgba(32, 32, 32, 0.1)",
      borderRadius: "16px",
      padding: "16px 24px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "12px",
      svg: {
        minWidth: "24px"
      }
    },
    "> a": {
      transition: "box-shadow 100ms ease-in, transform 100ms ease-in",
      ":hover": {
        boxShadow: "0px 4px 12px 0px rgba(32, 32, 32, 0.1)",
        transform: "translateY(-2px)"
      }
    },
    [mq.sm]: {
      "> *": {
        borderRadius: "16px",
        padding: "8px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        svg: {
          minWidth: "24px"
        },
        span: {
          fontSize: "14px"
        }
      }
    }
  };
}, "");
const Address = /* @__PURE__ */ createStyled("div", {
  target: "e7d5sbs3"
})(() => {
  return {};
}, "");
const Email = /* @__PURE__ */ createStyled("a", {
  target: "e7d5sbs2"
})(() => {
  return {
    textDecoration: "none",
    color: "inherit"
  };
}, "");
const Phone = /* @__PURE__ */ createStyled("a", {
  target: "e7d5sbs1"
})(() => {
  return {
    textDecoration: "none",
    color: "inherit"
  };
}, "");
const EmptyMessage$1 = /* @__PURE__ */ createStyled("p", {
  target: "e7d5sbs0"
})(() => {
  return {
    border: "1px solid rgba(32, 32, 32, 0.1)",
    borderRadius: "16px",
    padding: "16px 24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };
}, "");
const MAP_SOCIAL_TO_ICON$1 = {
  [Social.linkedIn]: SvgLinkedIn,
  [Social.youTube]: SvgYoutube,
  [Social.facebook]: SvgFacebook,
  [Social.twitter]: SvgTwitter,
  [Social.instagram]: SvgInstagram,
  [Social.tikTok]: SvgTikTok,
  [Social.telegram]: SvgTelegram
};
const Contacts$1 = () => {
  const content = useContent();
  const {
    email,
    phone,
    address,
    socials
  } = content.contacts;
  const isSocialsVisible = Object.values(socials).some((social) => {
    return social.isVisible;
  });
  const isMainContactsVisible = Boolean(email.isVisible || phone.isVisible || address.isVisible);
  const renderSocialContacts = () => {
    return Object.values(socials).map((social) => {
      var _a;
      const SocialContactIcon = (_a = MAP_SOCIAL_TO_ICON$1[social.id]) != null ? _a : Fragment;
      if (social.isVisible) {
        return /* @__PURE__ */ jsx(ContactsListItem, {
          children: /* @__PURE__ */ jsx(Link, {
            href: social.value,
            children: /* @__PURE__ */ jsx(SocialContactIcon, {})
          })
        }, social.id);
      }
      return null;
    });
  };
  return /* @__PURE__ */ jsx(Container$5, {
    children: /* @__PURE__ */ jsxs(Body$2, {
      children: [/* @__PURE__ */ jsx(Caption, {
        children: "Contact details"
      }), isSocialsVisible || isMainContactsVisible ? /* @__PURE__ */ jsxs(ContactsList, {
        children: [email.isVisible ? /* @__PURE__ */ jsx(ContactsListItem, {
          children: /* @__PURE__ */ jsxs(Email, {
            href: `mailto:${email.value}`,
            children: [/* @__PURE__ */ jsx(SvgEmail, {}), /* @__PURE__ */ jsx(Input, {
              children: email.value
            })]
          })
        }, "email") : null, phone.isVisible ? /* @__PURE__ */ jsx(ContactsListItem, {
          children: /* @__PURE__ */ jsxs(Phone, {
            href: `tel:${phone.value}`,
            children: [/* @__PURE__ */ jsx(SvgPhone, {}), /* @__PURE__ */ jsx(Input, {
              children: phone.value
            })]
          })
        }, "phone") : null, address.isVisible ? /* @__PURE__ */ jsx(ContactsListItem, {
          children: /* @__PURE__ */ jsxs(Address, {
            children: [/* @__PURE__ */ jsx(SvgAddress, {}), /* @__PURE__ */ jsx(Input, {
              children: address.value
            })]
          })
        }, "address") : null, renderSocialContacts()]
      }) : null, !isSocialsVisible && !isMainContactsVisible ? /* @__PURE__ */ jsx(EmptyMessage$1, {
        children: "Please add your contacts info"
      }) : null]
    })
  });
};
const Container$4 = /* @__PURE__ */ createStyled("footer", {
  target: "exbre5c4"
})(() => {
  return {
    display: "flex",
    justifyContent: "center",
    padding: "0 32px",
    marginTop: "56px",
    [mq.sm]: {
      padding: "0 24px",
      marginTop: "40px"
    }
  };
}, "");
const Body$1 = /* @__PURE__ */ createStyled("div", {
  target: "exbre5c3"
})(() => {
  return {
    width: "100%",
    borderTop: "1px solid rgba(32, 32, 32, 0.1)",
    maxWidth: "656px",
    gap: "32px",
    [mq.lg]: {
      maxWidth: "800px"
    },
    [mq.sm]: {
      gap: "24px"
    }
  };
}, "");
const Content$1 = /* @__PURE__ */ createStyled("div", {
  target: "exbre5c2"
})(() => {
  return {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "40px 0",
    gap: "32px",
    [mq.sm]: {
      padding: "16px 0 32px",
      justifyContent: "flex-start",
      flexDirection: "column",
      gap: "16px"
    }
  };
}, "");
const Copyright$1 = /* @__PURE__ */ createStyled(Input, {
  target: "exbre5c1"
})(() => {
  return {
    fontSize: "16px",
    lineHeight: "24px"
  };
}, "");
const PoweredByWorkee$1 = /* @__PURE__ */ createStyled(Input, {
  target: "exbre5c0"
})(() => {
  return {
    fontSize: "16px",
    lineHeight: "24px",
    opacity: 1,
    flexShrink: 0,
    [mq.sm]: {
      opacity: 0.3
    },
    a: {
      transition: "opacity 100ms ease-in",
      ":hover": {
        opacity: 0.7
      }
    }
  };
}, "");
const Footer$1 = () => {
  const content = useContent();
  const {
    name
  } = content.hero;
  const currentYear = new Date().getFullYear();
  return /* @__PURE__ */ jsx(Container$4, {
    children: /* @__PURE__ */ jsx(Body$1, {
      children: /* @__PURE__ */ jsxs(Content$1, {
        children: [/* @__PURE__ */ jsx(Copyright$1, {
          htmlTag: "p",
          children: `${currentYear} \xA9 ${name.value}`
        }), /* @__PURE__ */ jsx(PoweredByWorkee$1, {
          htmlTag: "p",
          children: /* @__PURE__ */ jsx(Link, {
            href: "https://workee.net",
            children: "Powered by Workee"
          })
        })]
      })
    })
  });
};
const Container$3 = /* @__PURE__ */ createStyled("div", {
  target: "eqllcx82"
})(() => {
  return {
    width: "100%",
    height: "100%",
    position: "relative",
    overflow: "hidden",
    [mq.lg]: {
      height: "auto",
      overflow: "visible",
      paddingTop: "80px"
    }
  };
}, "");
const HeroArea = /* @__PURE__ */ createStyled("div", {
  target: "eqllcx81"
})(() => {
  const heroWrapperSelector = `#${SectionContainerId.HERO_WRAPPER}`;
  return {
    position: "absolute",
    width: "50%",
    height: "100%",
    left: 0,
    top: 0,
    [heroWrapperSelector]: {
      height: "100%"
    },
    [mq.lg]: {
      position: "relative",
      width: "100%"
    }
  };
}, "");
const ContentArea = /* @__PURE__ */ createStyled("div", {
  target: "eqllcx80"
})(() => {
  const headerWrapperSelector = `#${SectionContainerId.HEADER_WRAPPER}`;
  return {
    marginLeft: "50%",
    width: "50%",
    height: "100%",
    overflow: "auto",
    backgroundColor: "rgba(255, 255, 255, 1)",
    [mq.lg]: {
      marginLeft: "0",
      width: "100%",
      [headerWrapperSelector]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "0",
        width: "100%",
        height: "80px"
      }
    }
  };
}, "");
const MinimalBookingPage = () => {
  const theme = useTheme();
  const content = useContent();
  return /* @__PURE__ */ jsx(TemplateStylesProvider$1, {
    theme,
    content,
    children: /* @__PURE__ */ jsxs(Container$3, {
      children: [/* @__PURE__ */ jsx(HeroArea, {
        children: /* @__PURE__ */ jsx(Hero$1, {})
      }), /* @__PURE__ */ jsxs(ContentArea, {
        children: [/* @__PURE__ */ jsx(Header, {}), /* @__PURE__ */ jsx(About, {}), /* @__PURE__ */ jsx(Jobs, {}), /* @__PURE__ */ jsx(Contacts$1, {}), /* @__PURE__ */ jsx(Footer$1, {})]
      })]
    })
  });
};
const generateActionStyles = (theme, variant) => {
  if (variant === ButtonVariant.CONTAINED) {
    return {
      fontFamily: theme.fonts.primary.fontFamily,
      fontWeight: theme.fonts.primary.fontWeight,
      fontStyle: theme.fonts.primary.fontStyle,
      color: "rgba(255, 255, 255, 1)",
      backgroundColor: theme.colors.primary,
      borderColor: theme.colors.primary,
      borderRadius: "16px"
    };
  }
  if (variant === ButtonVariant.OUTLINED) {
    return {
      fontFamily: theme.fonts.primary.fontFamily,
      fontWeight: theme.fonts.primary.fontWeight,
      fontStyle: theme.fonts.primary.fontStyle,
      color: theme.colors.primary,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderColor: theme.colors.primary,
      borderRadius: "16px"
    };
  }
  return {
    fontFamily: theme.fonts.primary.fontFamily,
    fontWeight: theme.fonts.primary.fontWeight,
    fontStyle: theme.fonts.primary.fontStyle,
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: theme.colors.primary,
    borderColor: theme.colors.primary,
    borderRadius: "16px"
  };
};
const generateTemplateStyles = (theme, content) => {
  return {
    hero: {
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderRadius: "24px",
      name: {
        fontFamily: theme.fonts.primary.fontFamily,
        fontWeight: theme.fonts.primary.fontWeight,
        fontStyle: theme.fonts.primary.fontStyle
      },
      image: {
        borderRadius: "24px"
      },
      primaryAction: generateActionStyles(theme, content.hero.primaryAction.variant),
      secondaryAction: generateActionStyles(theme, content.hero.secondaryAction.variant),
      bg: {
        backgroundColor: theme.colors.primary
      }
    },
    contacts: {
      color: theme.colors.primary,
      backgroundColor: "rgba(255, 255, 255, 1)",
      borderRadius: "24px"
    }
  };
};
const TemplateStylesContext = createContext(generateTemplateStyles(getDefaultTheme(), getDefaultContent()));
const TemplateStylesProvider = ({
  theme,
  content,
  children
}) => {
  const value = useMemo(() => {
    return generateTemplateStyles(theme, content);
  }, [theme, content]);
  return /* @__PURE__ */ jsx(TemplateStylesContext.Provider, {
    value,
    children
  });
};
const useTemplateStyles = () => {
  return useContext(TemplateStylesContext);
};
const SvgInfo = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM10.25 19V10.25H13.75V19H10.25ZM10.25 5V8.5H13.75V5H10.25Z",
  fill: "currentColor"
}));
const Section = /* @__PURE__ */ createStyled(Hero$3, {
  target: "epq7mn614"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    name
  } = templateStyles.hero;
  return {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    padding: "0 8px",
    [mq.lg]: {
      gap: "8px"
    },
    "#hero-name-wrapper": {
      fontFamily: name.fontFamily,
      fontWeight: name.fontWeight,
      fontStyle: name.fontStyle,
      fontSize: "32px",
      lineHeight: "130%",
      [mq.lg]: {
        fontSize: "24px"
      }
    },
    "#hero-title-wrapper": {
      fontSize: "18px",
      lineHeight: "150%"
    },
    "#hero-description-wrapper": {
      fontSize: "18px",
      lineHeight: "150%"
    }
  };
}, "");
const Body = /* @__PURE__ */ createStyled("div", {
  target: "epq7mn613"
})(() => {
  return {
    width: "100%",
    display: "flex",
    justifyContent: "center"
  };
}, "");
const Content = /* @__PURE__ */ createStyled("div", {
  target: "epq7mn612"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    borderRadius,
    backgroundColor
  } = templateStyles.hero;
  return {
    borderRadius,
    backgroundColor,
    position: "relative",
    width: "100%",
    maxWidth: "720px",
    padding: "32px",
    display: "grid",
    gridTemplateColumns: "240px auto",
    gridTemplateAreas: `
      "image text"
      `,
    gap: "40px",
    "#hero-image-wrapper": {
      zIndex: 2
    },
    [mq.lg]: {
      gridTemplateColumns: "auto",
      gridTemplateRows: "auto auto",
      gap: "24px",
      gridTemplateAreas: `
        "image" 
        "text"
        `,
      padding: "24px 8px"
    }
  };
}, "");
const HeroImage = /* @__PURE__ */ createStyled(Image$1, {
  target: "epq7mn611"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    borderRadius
  } = templateStyles.hero.image;
  return {
    borderRadius,
    display: "block",
    width: "100%",
    gridArea: "image",
    aspectRatio: "1 / 1",
    boxShadow: "0px 12px 24px 0px rgba(24, 24, 24, 0.1)",
    [mq.lg]: {
      maxWidth: "128px",
      margin: "0 auto"
    }
  };
}, "");
const TextContainer = /* @__PURE__ */ createStyled("div", {
  target: "epq7mn610"
})(() => {
  return {
    gridArea: "text",
    alignSelf: "start",
    paddingTop: "64px",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    gap: "8px",
    [mq.lg]: {
      paddingTop: 0,
      alignItems: "stretch",
      textAlign: "center"
    }
  };
}, "");
const Name = /* @__PURE__ */ createStyled(Name$4, {
  target: "epq7mn69"
})(() => {
  return {};
}, "");
const Title = /* @__PURE__ */ createStyled(Title$5, {
  target: "epq7mn68"
})(() => {
  return {
    opacity: 0.6
  };
}, "");
const Actions = /* @__PURE__ */ createStyled("div", {
  target: "epq7mn67"
})(() => {
  return {
    marginTop: "16px",
    display: "flex",
    gap: "8px",
    alignItems: "center",
    [mq.lg]: {
      justifyContent: "center"
    }
  };
}, "");
const PrimaryAction = /* @__PURE__ */ createStyled(PrimaryAction$3, {
  target: "epq7mn66"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius
  } = templateStyles.hero.primaryAction;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius,
    lineHeight: "150%",
    padding: "12px 24px",
    transition: "box-shadow 100ms ease-in, transform 100ms ease-in",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 4px 12px 0px rgba(32, 32, 32, 0.1)"
    },
    [mq.lg]: {
      padding: "8px 16px"
    }
  };
}, "");
const SecondaryAction = /* @__PURE__ */ createStyled(SecondaryAction$3, {
  target: "epq7mn65"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius
  } = templateStyles.hero.secondaryAction;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    color,
    backgroundColor,
    borderColor,
    borderRadius,
    lineHeight: "150%",
    padding: "12px 24px",
    transition: "box-shadow 100ms ease-in, transform 100ms ease-in",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 4px 12px 0px rgba(32, 32, 32, 0.1)"
    },
    [mq.lg]: {
      padding: "8px 16px"
    }
  };
}, "");
const BGBlur = /* @__PURE__ */ createStyled("div", {
  target: "epq7mn64"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    backgroundColor
  } = templateStyles.hero.bg;
  return {
    backgroundColor,
    position: "absolute",
    width: "100%",
    height: "64px",
    top: 0,
    left: 0,
    zIndex: 1,
    overflow: "hidden"
  };
}, "");
const BGBlurImage = /* @__PURE__ */ createStyled("img", {
  target: "epq7mn63"
})(() => {
  return {
    width: "100%",
    height: "100%",
    filter: "blur(32px)",
    mixBlendMode: "luminosity",
    opacity: 0.3
  };
}, "");
const DescriptionContainer = /* @__PURE__ */ createStyled("div", {
  target: "epq7mn62"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    borderRadius,
    backgroundColor
  } = templateStyles.hero;
  return {
    width: "100%",
    maxWidth: "720px",
    borderRadius,
    backgroundColor,
    padding: "24px 32px",
    display: "grid",
    gridTemplateColumns: "24px auto",
    gap: "24px",
    [mq.lg]: {
      padding: "16px",
      gap: "16px"
    }
  };
}, "");
const DescriptionIcon = /* @__PURE__ */ createStyled("div", {
  target: "epq7mn61"
})(() => {
  return {
    color: "rgba(32, 32, 32, 0.2)"
  };
}, "");
const Description = /* @__PURE__ */ createStyled(Description$7, {
  target: "epq7mn60"
})(() => {
  return {};
}, "");
const Hero = () => {
  const content = useContent();
  const {
    name,
    title,
    description,
    image,
    primaryAction,
    secondaryAction
  } = content.hero;
  return /* @__PURE__ */ jsxs(Section, {
    children: [/* @__PURE__ */ jsxs(Body, {
      children: [/* @__PURE__ */ jsxs(Content, {
        children: [/* @__PURE__ */ jsx(HeroImage, {
          src: image.value,
          alt: name.value
        }), /* @__PURE__ */ jsxs(TextContainer, {
          children: [/* @__PURE__ */ jsx(Name, {
            children: name.value
          }), /* @__PURE__ */ jsx(Title, {
            children: title.value
          }), /* @__PURE__ */ jsxs(Actions, {
            children: [/* @__PURE__ */ jsx(PrimaryAction, {
              variant: primaryAction.variant,
              children: primaryAction.value
            }), /* @__PURE__ */ jsx(SecondaryAction, {
              variant: secondaryAction.variant,
              children: secondaryAction.value
            })]
          })]
        })]
      }), /* @__PURE__ */ jsx(BGBlur, {
        children: /* @__PURE__ */ jsx(BGBlurImage, {
          src: image.value,
          alt: name.value
        })
      })]
    }), /* @__PURE__ */ jsxs(DescriptionContainer, {
      children: [/* @__PURE__ */ jsx(DescriptionIcon, {
        children: /* @__PURE__ */ jsx(SvgInfo, {})
      }), /* @__PURE__ */ jsx(Description, {
        children: description.value
      })]
    })]
  });
};
const Container$2 = /* @__PURE__ */ createStyled(Contacts$4, {
  target: "e1mf4qc07"
})(() => {
  return {
    padding: "0 8px",
    marginTop: "12px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",
    [mq.lg]: {
      gap: "8px",
      marginTop: "8px"
    }
  };
}, "");
const Contact = /* @__PURE__ */ createStyled("div", {
  target: "e1mf4qc06"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    backgroundColor,
    borderRadius
  } = templateStyles.contacts;
  return {
    width: "100%",
    maxWidth: "720px",
    "> *": {
      borderRadius,
      backgroundColor,
      width: "100%",
      padding: "16px 32px",
      fontSize: "18px",
      lineHeight: "150%",
      [mq.lg]: {
        padding: "16px"
      }
    },
    "> a": {
      display: "block",
      transition: "box-shadow 100ms ease-in, transform 100ms ease-in",
      ":hover": {
        transform: "translateY(-2px)",
        boxShadow: "0px 4px 12px 0px rgba(32, 32, 32, 0.1)"
      }
    }
  };
}, "");
const ContactItem = /* @__PURE__ */ createStyled("div", {
  target: "e1mf4qc05"
})(() => {
  return {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "24px",
    [mq.lg]: {
      gap: "16px"
    }
  };
}, "");
const ContactItemIcon = /* @__PURE__ */ createStyled("div", {
  target: "e1mf4qc04"
})(({
  isHighlighted
}) => {
  const templateStyles = useTemplateStyles();
  const {
    color
  } = templateStyles.contacts;
  const styles = {
    color: "rgba(32, 32, 32, 0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };
  if (isHighlighted) {
    styles.color = color;
  }
  return styles;
}, "");
const ContactItemText = /* @__PURE__ */ createStyled(Input, {
  target: "e1mf4qc03"
})(({
  isHighlighted
}) => {
  const templateStyles = useTemplateStyles();
  const {
    color
  } = templateStyles.contacts;
  const styles = {
    color: "rgba(32, 32, 32, 1)",
    fontSize: "18px"
  };
  if (isHighlighted) {
    styles.color = color;
  }
  return styles;
}, "");
const SocialsList = /* @__PURE__ */ createStyled("ul", {
  target: "e1mf4qc02"
})(() => {
  return {
    display: "flex",
    justifyContent: "center",
    margin: 0,
    padding: 0,
    listStyle: "none",
    gap: "12px",
    [mq.lg]: {
      gap: "8px",
      width: "100%",
      maxWidth: "720px"
    }
  };
}, "");
const SocialsListItem = /* @__PURE__ */ createStyled("li", {
  target: "e1mf4qc01"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    color,
    borderRadius,
    backgroundColor
  } = templateStyles.contacts;
  return {
    color,
    borderRadius,
    backgroundColor,
    padding: "16px 32px",
    lineHeight: 0,
    transition: "box-shadow 100ms ease-in, transform 100ms ease-in",
    ":hover": {
      transform: "translateY(-2px)",
      boxShadow: "0px 4px 12px 0px rgba(32, 32, 32, 0.1)"
    },
    [mq.lg]: {
      padding: "16px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    [mq.sm]: {
      padding: "8px"
    }
  };
}, "");
const EmptyMessage = /* @__PURE__ */ createStyled("p", {
  target: "e1mf4qc00"
})(() => {
  const templateStyles = useTemplateStyles();
  const {
    backgroundColor,
    borderRadius
  } = templateStyles.contacts;
  return {
    borderRadius,
    backgroundColor,
    width: "100%",
    maxWidth: "720px",
    padding: "16px 32px",
    fontSize: "18px",
    lineHeight: "150%",
    textAlign: "center",
    color: "rgba(32, 32, 32, 0.5)"
  };
}, "");
const MAP_SOCIAL_TO_ICON = {
  [Social.linkedIn]: SvgLinkedIn,
  [Social.youTube]: SvgYoutube,
  [Social.facebook]: SvgFacebook,
  [Social.twitter]: SvgTwitter,
  [Social.instagram]: SvgInstagram,
  [Social.tikTok]: SvgTikTok,
  [Social.telegram]: SvgTelegram
};
const Contacts = () => {
  const content = useContent();
  const {
    email,
    phone,
    address,
    socials
  } = content.contacts;
  const isSocialsVisible = Object.values(socials).some((social) => {
    return social.isVisible;
  });
  const isMainContactsVisible = Boolean(email.isVisible || phone.isVisible || address.isVisible);
  const renderSocialContacts = () => {
    return Object.values(socials).map((social) => {
      var _a;
      const SocialContactIcon = (_a = MAP_SOCIAL_TO_ICON[social.id]) != null ? _a : Fragment;
      if (social.isVisible) {
        return /* @__PURE__ */ jsx(Link, {
          href: social.value,
          children: /* @__PURE__ */ jsx(SocialsListItem, {
            children: /* @__PURE__ */ jsx(SocialContactIcon, {})
          })
        }, social.id);
      }
      return null;
    });
  };
  return /* @__PURE__ */ jsxs(Container$2, {
    children: [email.isVisible ? /* @__PURE__ */ jsx(Contact, {
      children: /* @__PURE__ */ jsx(Link, {
        href: `mailto:${email.value}`,
        children: /* @__PURE__ */ jsxs(ContactItem, {
          children: [/* @__PURE__ */ jsx(ContactItemIcon, {
            isHighlighted: true,
            children: /* @__PURE__ */ jsx(SvgEmail, {})
          }), /* @__PURE__ */ jsx(ContactItemText, {
            isHighlighted: true,
            children: email.value
          })]
        })
      })
    }, "email") : null, phone.isVisible ? /* @__PURE__ */ jsx(Contact, {
      children: /* @__PURE__ */ jsx(Link, {
        href: `tel:${phone.value}`,
        children: /* @__PURE__ */ jsxs(ContactItem, {
          children: [/* @__PURE__ */ jsx(ContactItemIcon, {
            isHighlighted: true,
            children: /* @__PURE__ */ jsx(SvgPhone, {})
          }), /* @__PURE__ */ jsx(ContactItemText, {
            isHighlighted: true,
            children: phone.value
          })]
        })
      })
    }, "phone") : null, address.isVisible ? /* @__PURE__ */ jsx(Contact, {
      children: /* @__PURE__ */ jsxs(ContactItem, {
        children: [/* @__PURE__ */ jsx(ContactItemIcon, {
          children: /* @__PURE__ */ jsx(SvgAddress, {})
        }), /* @__PURE__ */ jsx(ContactItemText, {
          children: address.value
        })]
      })
    }, "address") : null, isSocialsVisible ? /* @__PURE__ */ jsx(SocialsList, {
      children: renderSocialContacts()
    }) : null, !isSocialsVisible && !isMainContactsVisible ? /* @__PURE__ */ jsx(EmptyMessage, {
      children: "Please add your contacts info"
    }) : null]
  });
};
const Container$1 = /* @__PURE__ */ createStyled("footer", {
  target: "e1xtwkc02"
})(() => {
  return {
    padding: "32px",
    backgroundColor: "rgba(245, 245, 245, 1)",
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  };
}, "");
const Copyright = /* @__PURE__ */ createStyled(Input, {
  target: "e1xtwkc01"
})(() => {
  return {
    fontSize: "18px",
    lineHeight: "150%"
  };
}, "");
const PoweredByWorkee = /* @__PURE__ */ createStyled(Input, {
  target: "e1xtwkc00"
})(() => {
  return {
    fontSize: "14px",
    lineHeight: "150%",
    opacity: 0.4,
    marginTop: "16px",
    transition: "opacity 100ms ease-in",
    ":hover": {
      opacity: 1
    }
  };
}, "");
const Footer = () => {
  const content = useContent();
  const {
    name
  } = content.hero;
  const currentYear = new Date().getFullYear();
  return /* @__PURE__ */ jsxs(Container$1, {
    children: [/* @__PURE__ */ jsx(Copyright, {
      htmlTag: "h2",
      children: `${currentYear} \xA9 ${name.value}`
    }), /* @__PURE__ */ jsx(PoweredByWorkee, {
      htmlTag: "h4",
      children: /* @__PURE__ */ jsx(Link, {
        href: "https://workee.net",
        children: "Powered by Workee"
      })
    })]
  });
};
const Container = /* @__PURE__ */ createStyled("div", {
  target: "evwe4310"
})(() => {
  return {
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(245, 245, 245, 1)",
    position: "relative"
  };
}, "");
const BusinessCardBasic = () => {
  const theme = useTheme();
  const content = useContent();
  return /* @__PURE__ */ jsx(TemplateStylesProvider, {
    theme,
    content,
    children: /* @__PURE__ */ jsxs(Container, {
      children: [/* @__PURE__ */ jsx(Hero, {}), /* @__PURE__ */ jsx(Contacts, {}), /* @__PURE__ */ jsx(Footer, {})]
    })
  });
};
const getFontImportSearchQueryString = ({
  fontFamily,
  fontWeight,
  fontStyle
}) => {
  return `family=${fontFamily.replace(" ", "+")}:ital,wght@${fontStyle === "italic" ? 1 : 0},${fontWeight}`;
};
const FontImporter = () => {
  const theme = useTheme();
  const {
    primary,
    secondary
  } = theme.fonts;
  return /* @__PURE__ */ jsx(Global, {
    styles: /* @__PURE__ */ css('@import url("https://fonts.googleapis.com/css2?', getFontImportSearchQueryString(primary), "&", getFontImportSearchQueryString(secondary), '&display=swap");{}', "")
  });
};
const WebsiteContainer = /* @__PURE__ */ createStyled("main", {
  target: "e1u4n57g0"
})(() => {
  const theme = useTheme();
  const {
    fontFamily,
    fontWeight,
    fontStyle
  } = theme.fonts.secondary;
  return {
    fontFamily,
    fontWeight,
    fontStyle,
    isolation: "isolate",
    position: "relative",
    width: "100%",
    height: "100%",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap"
  };
}, "");
const WebsiteBuilder = ({
  template,
  content,
  theme,
  wrappers,
  handlers
}) => {
  return /* @__PURE__ */ jsx(WrappersProvider, {
    value: merge(defaultWrappers, wrappers),
    children: /* @__PURE__ */ jsx(HandlersProvider, {
      value: merge(defaultHandlers, handlers),
      children: /* @__PURE__ */ jsxs(ThemeProvider, {
        value: theme,
        children: [/* @__PURE__ */ jsx(FontImporter, {}), /* @__PURE__ */ jsx(ContentProvider, {
          value: content,
          children: /* @__PURE__ */ jsxs(WebsiteContainer, {
            children: [template.name === TemplateName.BASIC ? /* @__PURE__ */ jsx(Basic, {}) : null, template.name === TemplateName.MINIMAL_BOOKING_PAGE ? /* @__PURE__ */ jsx(MinimalBookingPage, {}) : null, template.name === TemplateName.BUSINESS_CARD_BASIC ? /* @__PURE__ */ jsx(BusinessCardBasic, {}) : null]
          })
        })]
      })
    })
  });
};
export { ButtonVariant, LogoDisplayVariant, SectionContainerId, Social, TemplateName, WebsiteBuilder };
//# sourceMappingURL=index.es.js.map
